(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  /**
 * GlitchTip (protocolo Sentry) — inicialização browser-only + interceptors.
 * Vue: use attachErrorHandler de @sentry/vue em App.js (evita puxar @sentry/vue no bundle main.js).
 */ // This is a magic string replaced by rollup
const $ecf2bd8eabf48f5f$export$31499a9cd224b78c = "10.51.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $21592f648406440f$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $0dc2d2125eba808b$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $0dc2d2125eba808b$export$c8bfa33e4e8ae492((0, $21592f648406440f$export$f1a6cdb1459e81d1));
    return 0, $21592f648406440f$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $0dc2d2125eba808b$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c] = __SENTRY__[0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $0dc2d2125eba808b$export$7e223ec222791509(name, creator, obj = (0, $21592f648406440f$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c] = __SENTRY__[0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4ffc93ad374b9e74$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



// eslint-disable-next-line @typescript-eslint/unbound-method
const $e73c4a1df54c54bb$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$e6127cc7fe7395c3(wat) {
    switch($e73c4a1df54c54bb$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $e73c4a1df54c54bb$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$var$isBuiltin(wat, className) {
    return $e73c4a1df54c54bb$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$9f9636d330b71954(wat) {
    return $e73c4a1df54c54bb$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$ef9e2056653f0c8e(wat) {
    return $e73c4a1df54c54bb$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$12e869b2a583f783(wat) {
    return $e73c4a1df54c54bb$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$844ec244b1367d54(wat) {
    return $e73c4a1df54c54bb$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$c3825b437cbdea5c(wat) {
    return wat === null || $e73c4a1df54c54bb$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$53b83ca8eaab0383(wat) {
    return $e73c4a1df54c54bb$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $e73c4a1df54c54bb$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $e73c4a1df54c54bb$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$49841c62b9eff15(wat) {
    return $e73c4a1df54c54bb$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $e73c4a1df54c54bb$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$bc2894c7158efbac(wat) {
    return $e73c4a1df54c54bb$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $e73c4a1df54c54bb$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e73c4a1df54c54bb$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $e73c4a1df54c54bb$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $e73c4a1df54c54bb$export$49034edbe6b62415(request, Request);
}



const $89173479274f9ad5$var$WINDOW = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
const $89173479274f9ad5$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $89173479274f9ad5$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $89173479274f9ad5$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $89173479274f9ad5$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $89173479274f9ad5$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($89173479274f9ad5$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $e73c4a1df54c54bb$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $89173479274f9ad5$export$1cfafeee2987818b() {
    try {
        return $89173479274f9ad5$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $89173479274f9ad5$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$89173479274f9ad5$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}





const $850185d9d2292f1a$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** Prefix for logging strings */ const $850185d9d2292f1a$var$PREFIX = "Sentry Logger ";
/** This may be mutated by the console instrumentation. */ const $850185d9d2292f1a$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $850185d9d2292f1a$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $21592f648406440f$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $21592f648406440f$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($850185d9d2292f1a$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $850185d9d2292f1a$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $850185d9d2292f1a$var$enable() {
    $850185d9d2292f1a$var$_getLoggerSettings().enabled = true;
}
function $850185d9d2292f1a$var$disable() {
    $850185d9d2292f1a$var$_getLoggerSettings().enabled = false;
}
function $850185d9d2292f1a$var$isEnabled() {
    return $850185d9d2292f1a$var$_getLoggerSettings().enabled;
}
function $850185d9d2292f1a$var$log(...args) {
    $850185d9d2292f1a$var$_maybeLog("log", ...args);
}
function $850185d9d2292f1a$var$warn(...args) {
    $850185d9d2292f1a$var$_maybeLog("warn", ...args);
}
function $850185d9d2292f1a$var$error(...args) {
    $850185d9d2292f1a$var$_maybeLog("error", ...args);
}
function $850185d9d2292f1a$var$_maybeLog(level, ...args) {
    if (!(0, $4ffc93ad374b9e74$export$16a28057038b10ef)) return;
    if ($850185d9d2292f1a$var$isEnabled()) $850185d9d2292f1a$export$cda52e2a8927a2ca(()=>{
        (0, $21592f648406440f$export$f1a6cdb1459e81d1).console[level](`${$850185d9d2292f1a$var$PREFIX}[${level}]:`, ...args);
    });
}
function $850185d9d2292f1a$var$_getLoggerSettings() {
    if (!(0, $4ffc93ad374b9e74$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $0dc2d2125eba808b$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $850185d9d2292f1a$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $850185d9d2292f1a$var$enable,
    disable: /** Disable logging. */ $850185d9d2292f1a$var$disable,
    isEnabled: /** Check if logging is enabled. */ $850185d9d2292f1a$var$isEnabled,
    log: /** Log a message. */ $850185d9d2292f1a$var$log,
    warn: /** Log a warning. */ $850185d9d2292f1a$var$warn,
    error: /** Log an error. */ $850185d9d2292f1a$var$error
};



/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $1bc3c607cc1507c7$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $1bc3c607cc1507c7$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $1bc3c607cc1507c7$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $1bc3c607cc1507c7$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $1bc3c607cc1507c7$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function $1bc3c607cc1507c7$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($1bc3c607cc1507c7$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $1bc3c607cc1507c7$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1bc3c607cc1507c7$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $1bc3c607cc1507c7$export$62ff257738bf57f5(value) {
    if ((0, $e73c4a1df54c54bb$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$1bc3c607cc1507c7$var$getOwnProperties(value)
    };
    else if ((0, $e73c4a1df54c54bb$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $1bc3c607cc1507c7$var$serializeEventTarget(value.target),
            currentTarget: $1bc3c607cc1507c7$var$serializeEventTarget(value.currentTarget),
            ...$1bc3c607cc1507c7$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $e73c4a1df54c54bb$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $1bc3c607cc1507c7$var$serializeEventTarget(target) {
    try {
        return (0, $e73c4a1df54c54bb$export$45a5e7f76e0caa8d)(target) ? (0, $89173479274f9ad5$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch  {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $1bc3c607cc1507c7$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $1bc3c607cc1507c7$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($1bc3c607cc1507c7$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $1bc3c607cc1507c7$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $1bc3c607cc1507c7$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $1bc3c607cc1507c7$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($1bc3c607cc1507c7$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($1bc3c607cc1507c7$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $1bc3c607cc1507c7$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $1bc3c607cc1507c7$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $1bc3c607cc1507c7$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $e73c4a1df54c54bb$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



// undefined = not yet resolved, null = no runner found, function = runner found
let $f8b69a19c3af2f20$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $f8b69a19c3af2f20$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($f8b69a19c3af2f20$var$RESOLVED_RUNNER !== undefined) return $f8b69a19c3af2f20$var$RESOLVED_RUNNER ? $f8b69a19c3af2f20$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $f8b69a19c3af2f20$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $f8b69a19c3af2f20$var$RESOLVED_RUNNER(cb);
    }
    $f8b69a19c3af2f20$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $f8b69a19c3af2f20$export$9869d72de32a3917() {
    return $f8b69a19c3af2f20$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $f8b69a19c3af2f20$export$65b1bada40c91b34() {
    return $f8b69a19c3af2f20$export$ff239213cb80e2da(()=>Date.now());
}



const $b0bde6307b9dc37e$var$STACKTRACE_FRAME_LIMIT = 50;
const $b0bde6307b9dc37e$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $b0bde6307b9dc37e$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $b0bde6307b9dc37e$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $b0bde6307b9dc37e$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $b0bde6307b9dc37e$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($b0bde6307b9dc37e$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $b0bde6307b9dc37e$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $b0bde6307b9dc37e$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $b0bde6307b9dc37e$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $b0bde6307b9dc37e$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $b0bde6307b9dc37e$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($b0bde6307b9dc37e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($b0bde6307b9dc37e$var$STRIP_FRAME_REGEXP.test($b0bde6307b9dc37e$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($b0bde6307b9dc37e$var$STRIP_FRAME_REGEXP.test($b0bde6307b9dc37e$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $b0bde6307b9dc37e$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $b0bde6307b9dc37e$var$getLastStackFrame(localStack).filename,
            function: frame.function || $b0bde6307b9dc37e$export$27c7e15d453fc0ac
        }));
}
function $b0bde6307b9dc37e$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $b0bde6307b9dc37e$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $b0bde6307b9dc37e$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $b0bde6307b9dc37e$var$defaultFunctionName;
        return fn.name || $b0bde6307b9dc37e$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b0bde6307b9dc37e$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $b0bde6307b9dc37e$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $b0bde6307b9dc37e$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = "__v_isVNode" in value && value.__v_isVNode;
    return isVNode ? "[VueVNode]" : "[VueViewModel]";
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $b0bde6307b9dc37e$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $937c50c58c7016cb$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $937c50c58c7016cb$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $937c50c58c7016cb$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $e73c4a1df54c54bb$export$7916fad0ebc23f48)(value)) output.push((0, $b0bde6307b9dc37e$export$b6d9c5eb2330759f)(value));
            else output.push(String(value));
        } catch  {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $937c50c58c7016cb$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $e73c4a1df54c54bb$export$844ec244b1367d54)(value)) return false;
    if ((0, $e73c4a1df54c54bb$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $e73c4a1df54c54bb$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $937c50c58c7016cb$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$937c50c58c7016cb$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}



function $c50b6b986a937e54$var$getCrypto() {
    const gbl = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $c50b6b986a937e54$var$emptyUuid;
function $c50b6b986a937e54$var$getRandomByte() {
    return (0, $f8b69a19c3af2f20$export$9869d72de32a3917)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $c50b6b986a937e54$export$19f53698e68b2496(crypto = $c50b6b986a937e54$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $f8b69a19c3af2f20$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$c50b6b986a937e54$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $c50b6b986a937e54$var$emptyUuid = "10000000100040008000100000000000";
    return $c50b6b986a937e54$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($c50b6b986a937e54$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $c50b6b986a937e54$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $c50b6b986a937e54$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c50b6b986a937e54$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $c50b6b986a937e54$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $c50b6b986a937e54$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c50b6b986a937e54$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $c50b6b986a937e54$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $c50b6b986a937e54$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $c50b6b986a937e54$export$d364f2020ab30578(input) {
    const match = input.match($c50b6b986a937e54$var$SEMVER_REGEXP) || [];
    const major = $c50b6b986a937e54$var$_parseInt(match[1]);
    const minor = $c50b6b986a937e54$var$_parseInt(match[2]);
    const patch = $c50b6b986a937e54$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $c50b6b986a937e54$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $937c50c58c7016cb$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $937c50c58c7016cb$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $937c50c58c7016cb$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $c50b6b986a937e54$export$6de4ffac6a2f1098(exception) {
    if ($c50b6b986a937e54$export$4a38e013f66150b(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $c50b6b986a937e54$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}




const $9a227e6c9c778209$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $9a227e6c9c778209$export$7740643b9eeaf0c4() {
    return (0, $f8b69a19c3af2f20$export$65b1bada40c91b34)() / $9a227e6c9c778209$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $9a227e6c9c778209$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $9a227e6c9c778209$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $f8b69a19c3af2f20$export$ff239213cb80e2da)(()=>performance.now())) / $9a227e6c9c778209$var$ONE_SECOND_IN_MS;
    };
}
let $9a227e6c9c778209$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $9a227e6c9c778209$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $9a227e6c9c778209$var$_cachedTimestampInSeconds ?? ($9a227e6c9c778209$var$_cachedTimestampInSeconds = $9a227e6c9c778209$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $9a227e6c9c778209$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $9a227e6c9c778209$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $f8b69a19c3af2f20$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $f8b69a19c3af2f20$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $9a227e6c9c778209$export$baf075a948ffc0bf() {
    if ($9a227e6c9c778209$var$cachedTimeOrigin === null) $9a227e6c9c778209$var$cachedTimeOrigin = $9a227e6c9c778209$var$getBrowserTimeOrigin();
    return $9a227e6c9c778209$var$cachedTimeOrigin;
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e2b7371c0209d323$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $c50b6b986a937e54$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e2b7371c0209d323$var$sessionToJSON(session)
    };
    if (context) $e2b7371c0209d323$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e2b7371c0209d323$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $c50b6b986a937e54$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e2b7371c0209d323$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $e2b7371c0209d323$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e2b7371c0209d323$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $86056d80eaaa46ab$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $86056d80eaaa46ab$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $259db5316e19a1fc$export$dc6d7ea554bcce10() {
    return (0, $c50b6b986a937e54$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $259db5316e19a1fc$export$295213bc4d0c54ad() {
    return (0, $c50b6b986a937e54$export$19f53698e68b2496)().substring(16);
}




const $3642608fa82531c9$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $3642608fa82531c9$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(scope, $3642608fa82531c9$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$3642608fa82531c9$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $3642608fa82531c9$export$91f063ebb8eff307(scope) {
    return scope[$3642608fa82531c9$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $a7665540edab3cc5$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $a7665540edab3cc5$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $f8b69a19c3af2f20$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $a7665540edab3cc5$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $3642608fa82531c9$export$3f25fa50c18e20ca)(newScope, (0, $3642608fa82531c9$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $e2b7371c0209d323$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $a7665540edab3cc5$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $e73c4a1df54c54bb$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, $3642608fa82531c9$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $f8b69a19c3af2f20$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $a7665540edab3cc5$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $9a227e6c9c778209$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $937c50c58c7016cb$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $3642608fa82531c9$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $86056d80eaaa46ab$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $c50b6b986a937e54$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $c50b6b986a937e54$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $c50b6b986a937e54$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $f5ff4a8b88e9eb8f$export$6f1b9191db9c4d5() {
    return (0, $0dc2d2125eba808b$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $a7665540edab3cc5$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $f5ff4a8b88e9eb8f$export$de9862929b76bf57() {
    return (0, $0dc2d2125eba808b$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $a7665540edab3cc5$export$775b6bb06e53a214)());
}



const $e252648c6f13e86b$var$isActualPromise = (p)=>p instanceof Promise && !p[$e252648c6f13e86b$var$kChainedCopy];
const $e252648c6f13e86b$var$kChainedCopy = Symbol("chained PromiseLike");
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const $e252648c6f13e86b$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return $e252648c6f13e86b$var$isActualPromise(chained) && $e252648c6f13e86b$var$isActualPromise(original) ? chained : $e252648c6f13e86b$var$copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e252648c6f13e86b$var$copyProps = (original, chained)=>{
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$e252648c6f13e86b$var$kChainedCopy]: true
    });
    return chained;
};




/**
 * This is an object that holds a stack of scopes.
 */ class $765e8609302f3111$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $a7665540edab3cc5$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $a7665540edab3cc5$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $e252648c6f13e86b$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $765e8609302f3111$var$getAsyncContextStack() {
    const registry = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const sentry = (0, $0dc2d2125eba808b$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $765e8609302f3111$export$d36ec451f120cfba((0, $f5ff4a8b88e9eb8f$export$6f1b9191db9c4d5)(), (0, $f5ff4a8b88e9eb8f$export$de9862929b76bf57)());
}
function $765e8609302f3111$var$withScope(callback) {
    return $765e8609302f3111$var$getAsyncContextStack().withScope(callback);
}
function $765e8609302f3111$var$withSetScope(scope, callback) {
    const stack = $765e8609302f3111$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $765e8609302f3111$var$withIsolationScope(callback) {
    return $765e8609302f3111$var$getAsyncContextStack().withScope(()=>{
        return callback($765e8609302f3111$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $765e8609302f3111$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $765e8609302f3111$var$withIsolationScope,
        withScope: $765e8609302f3111$var$withScope,
        withSetScope: $765e8609302f3111$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $765e8609302f3111$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$765e8609302f3111$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$765e8609302f3111$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4c55c7af4f9581a9$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const sentry = (0, $0dc2d2125eba808b$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $4c55c7af4f9581a9$export$f639b0c2752203be(carrier) {
    const sentry = (0, $0dc2d2125eba808b$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $765e8609302f3111$export$329d4d4d54e42710)();
}





let $23ec97ae524075cc$var$_externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function $23ec97ae524075cc$export$b5defb3466e9689b(fn) {
    $23ec97ae524075cc$var$_externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function $23ec97ae524075cc$export$92547f779c920a71() {
    return $23ec97ae524075cc$var$_externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function $23ec97ae524075cc$export$53f0ae651a1c4298() {
    return $23ec97ae524075cc$var$_externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function $23ec97ae524075cc$export$c7be4b0125a10cba() {
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const acs = (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $23ec97ae524075cc$export$68f3af03034c9e90() {
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const acs = (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $23ec97ae524075cc$export$aa55d5ab8e05984f() {
    return (0, $0dc2d2125eba808b$export$7e223ec222791509)("globalScope", ()=>new (0, $a7665540edab3cc5$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $23ec97ae524075cc$export$ec58d9285c204497(...rest) {
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const acs = (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $23ec97ae524075cc$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const acs = (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $23ec97ae524075cc$export$6bb76d6eba7e258c() {
    return $23ec97ae524075cc$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $23ec97ae524075cc$export$1e83db7ee4876dc4(scope) {
    const externalContext = $23ec97ae524075cc$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $259db5316e19a1fc$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $c15d0003e83e1f09$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $c15d0003e83e1f09$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $c15d0003e83e1f09$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $9a227e6c9c778209$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $850185d9d2292f1a$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}








/**
 * Use this attribute to represent the source of a span name.
 * Must be one of: custom, url, route, view, component, task
 * TODO(v11): rename this to sentry.span.source'
 */ const $d58f778607a31700$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $d58f778607a31700$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $d58f778607a31700$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $d58f778607a31700$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $d58f778607a31700$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $d58f778607a31700$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $d58f778607a31700$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $d58f778607a31700$export$69cd5c610c7bb96a = "sentry.measurement_value";
/** The release version of the application */ const $d58f778607a31700$export$f5cefb258679b29e = "sentry.release";
/** The environment name (e.g., "production", "staging", "development") */ const $d58f778607a31700$export$d1b1dbb47f5ba57c = "sentry.environment";
/** The segment name (e.g., "GET /users") */ const $d58f778607a31700$export$4626f2be16112c1c = "sentry.segment.name";
/** The id of the segment that this span belongs to. */ const $d58f778607a31700$export$25fa4a1832d3736a = "sentry.segment.id";
/** The name of the Sentry SDK (e.g., "sentry.php", "sentry.javascript") */ const $d58f778607a31700$export$87a4807042e1f1bb = "sentry.sdk.name";
/** The version of the Sentry SDK */ const $d58f778607a31700$export$301ebe936458e291 = "sentry.sdk.version";
/** The user ID (gated by sendDefaultPii) */ const $d58f778607a31700$export$1f9cc1d34ea098a0 = "user.id";
/** The user email (gated by sendDefaultPii) */ const $d58f778607a31700$export$b7466609ef46c07e = "user.email";
/** The user IP address (gated by sendDefaultPii) */ const $d58f778607a31700$export$8d592bdaea63b930 = "user.ip_address";
/** The user username (gated by sendDefaultPii) */ const $d58f778607a31700$export$c05ee933d3f74b2b = "user.name";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $d58f778607a31700$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $d58f778607a31700$export$1efec95406bbe327 = "sentry.profile_id";
const $d58f778607a31700$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $d58f778607a31700$export$b016f89ac1066ec = "cache.hit";
const $d58f778607a31700$export$3110e4c3f4386399 = "cache.key";
const $d58f778607a31700$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $d58f778607a31700$export$be7a251980e7e946 = "http.request.method";
const $d58f778607a31700$export$25dfd73e0e32c6e1 = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $d58f778607a31700$export$ff77b5fd5b2d627b = "sentry.link.type";
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $d58f778607a31700$export$71a4a707257f2774 = "gen_ai.conversation.id";





const $41d6d78bdb0c221c$export$6e69537d67fa20f = "sentry-";
const $41d6d78bdb0c221c$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $41d6d78bdb0c221c$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $41d6d78bdb0c221c$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $41d6d78bdb0c221c$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($41d6d78bdb0c221c$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($41d6d78bdb0c221c$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $41d6d78bdb0c221c$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$41d6d78bdb0c221c$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $41d6d78bdb0c221c$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $41d6d78bdb0c221c$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $e73c4a1df54c54bb$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $41d6d78bdb0c221c$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $41d6d78bdb0c221c$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $41d6d78bdb0c221c$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $41d6d78bdb0c221c$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $41d6d78bdb0c221c$export$bdd844ddb2def819) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}





/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $e644c3f3fd5f6954$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $e644c3f3fd5f6954$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function $e644c3f3fd5f6954$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(value)) return (0, $e252648c6f13e86b$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $0d56708971d86f7f$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $a00cd1cf06026f0b$var$logIgnoredSpan(droppedSpan) {
    (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $a00cd1cf06026f0b$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($a00cd1cf06026f0b$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $937c50c58c7016cb$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && $a00cd1cf06026f0b$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $937c50c58c7016cb$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $937c50c58c7016cb$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$a00cd1cf06026f0b$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches`, `opMatches`, or `attrsMatch`. So in contrary to how this looks,
        // not all of op, name, and attributes actually have to match. This is the most efficient way to check
        // for all combinations of name, op, and attribute patterns.
        if (nameMatches && opMatches && attrsMatch) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && $a00cd1cf06026f0b$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $a00cd1cf06026f0b$var$_matchesAttributeValue(actual, pat) {
    // String values support pattern matching
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $937c50c58c7016cb$export$cdded5b28a5f8c6d)(actual, pat);
    // Arrays: element-wise strict equality
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    // Primitives: strict equality
    return actual === pat;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $a00cd1cf06026f0b$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $a00cd1cf06026f0b$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


/**
 * Determines if span streaming is enabled for the given client
 */ function $19ac0dd3041e6bff$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}


/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $eabe7a363b55f68b$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}







/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $1e978d8ec5f865cd$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $1e978d8ec5f865cd$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $1e978d8ec5f865cd$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $1e978d8ec5f865cd$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $1e978d8ec5f865cd$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $1e978d8ec5f865cd$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * Estimates the serialized byte size of {@link Attributes},
 * with a couple of heuristics for performance.
 */ function $1e978d8ec5f865cd$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) // Assumption: Individual array items have the same type and roughly the same size
        // probably not always true but allows us to cut down on runtime
        weight += $1e978d8ec5f865cd$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $e73c4a1df54c54bb$export$c3825b437cbdea5c)(val)) weight += $1e978d8ec5f865cd$var$estimatePrimitiveSizeInBytes(val);
        else // default fallback for anything else (objects)
        weight += 100;
    }
    return weight;
}
function $1e978d8ec5f865cd$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $1e978d8ec5f865cd$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}





const $2753bacab4d59770$export$136e25984ba4a383 = 0;
const $2753bacab4d59770$export$58f7963109c806fc = 1;
const $2753bacab4d59770$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $2753bacab4d59770$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $2753bacab4d59770$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $2753bacab4d59770$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $2753bacab4d59770$export$f966a0446ece71e,
        message: "internal_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $2753bacab4d59770$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $2753bacab4d59770$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




/**
 * Interface representing a weak reference to an object.
 * This matches the standard WeakRef interface but is defined here
 * because WeakRef is not available in ES2020 type definitions.
 */ /**
 * Creates a weak reference to an object if WeakRef is available,
 * otherwise returns the object directly.
 *
 * This is useful for breaking circular references while maintaining
 * compatibility with environments that don't support WeakRef (e.g., older browsers).
 *
 * @param value - The object to create a weak reference to
 * @returns A WeakRef wrapper if available, or the original object as fallback
 */ function $9550740613cc6567$export$f0b98edec95fcb33(value) {
    try {
        // @ts-expect-error - WeakRef may not be in the type definitions for older TS targets
        const WeakRefImpl = (0, $21592f648406440f$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {
    // WeakRef not available or construction failed
    }
    return value;
}
/**
 * Resolves a potentially weak reference, returning the underlying object
 * or undefined if the reference has been garbage collected.
 *
 * @param ref - A MaybeWeakRef or undefined
 * @returns The referenced object, or undefined if GC'd or ref was undefined
 */ function $9550740613cc6567$export$a0592ad8c3586cf(ref) {
    if (!ref) return undefined;
    // Check if this is a WeakRef (has deref method)
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        // deref() failed - treat as GC'd
        return undefined;
    }
    // Direct reference fallback
    return ref;
}


const $bad21278ffba8b28$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $bad21278ffba8b28$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $bad21278ffba8b28$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(span, $bad21278ffba8b28$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $9550740613cc6567$export$f0b98edec95fcb33)(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(span, $bad21278ffba8b28$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $bad21278ffba8b28$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$bad21278ffba8b28$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $9550740613cc6567$export$a0592ad8c3586cf)(spanWithScopes[$bad21278ffba8b28$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}









/** Regular expression used to extract org ID from a DSN host. */ const $6224c48abfdf0275$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $6224c48abfdf0275$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $6224c48abfdf0275$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $6224c48abfdf0275$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $6224c48abfdf0275$export$b892860177f70a30(str) {
    const match = $6224c48abfdf0275$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $850185d9d2292f1a$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $6224c48abfdf0275$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $6224c48abfdf0275$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $6224c48abfdf0275$var$validateDsn(dsn) {
    if (!(0, $4ffc93ad374b9e74$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$6224c48abfdf0275$var$isValidProtocol(protocol)) {
        (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $6224c48abfdf0275$export$5914f4e7748c29c9(host) {
    const match = host.match($6224c48abfdf0275$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $6224c48abfdf0275$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $6224c48abfdf0275$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $6224c48abfdf0275$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $6224c48abfdf0275$export$b892860177f70a30(from) : $6224c48abfdf0275$var$dsnFromComponents(from);
    if (!components || !$6224c48abfdf0275$var$validateDsn(components)) return undefined;
    return components;
}





// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $95469603e83f0479$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $95469603e83f0479$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($95469603e83f0479$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $95469603e83f0479$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $95469603e83f0479$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $41d6d78bdb0c221c$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $f8b69a19c3af2f20$export$9869d72de32a3917)()
    };
    const sampleRand = $95469603e83f0479$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $95469603e83f0479$export$f35d907436da45cf(traceId = (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)(), spanId = (0, $259db5316e19a1fc$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $95469603e83f0479$export$1aff3752542747dd(traceId = (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)(), spanId = (0, $259db5316e19a1fc$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $95469603e83f0479$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $eabe7a363b55f68b$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $eabe7a363b55f68b$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, $f8b69a19c3af2f20$export$9869d72de32a3917)() * parsedSampleRate : parsedSampleRate + (0, $f8b69a19c3af2f20$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, $f8b69a19c3af2f20$export$9869d72de32a3917)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $95469603e83f0479$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $6224c48abfdf0275$export$b7ac9b8efa4bb595)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




// These are aligned with OpenTelemetry trace flags
const $f5169fe230b9fd92$export$208d5b368507fb8b = 0x0;
const $f5169fe230b9fd92$export$eb571cd9b5d98de8 = 0x1;
let $f5169fe230b9fd92$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $f5169fe230b9fd92$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $f5169fe230b9fd92$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $f5169fe230b9fd92$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $f5169fe230b9fd92$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $bad21278ffba8b28$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $259db5316e19a1fc$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $f5169fe230b9fd92$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $f5169fe230b9fd92$export$5caecac1caaf3a71(span);
    return (0, $95469603e83f0479$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $f5169fe230b9fd92$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $f5169fe230b9fd92$export$5caecac1caaf3a71(span);
    return (0, $95469603e83f0479$export$1aff3752542747dd)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $f5169fe230b9fd92$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $f5169fe230b9fd92$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Converts the span links array to a flattened version with serialized attributes for V2 spans.
 *
 * If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $f5169fe230b9fd92$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $f5169fe230b9fd92$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $f5169fe230b9fd92$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $f5169fe230b9fd92$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $f5169fe230b9fd92$var$ensureTimestampInSeconds(input.getTime());
    return (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $f5169fe230b9fd92$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $f5169fe230b9fd92$export$92d8c23565496537(span) {
    if ($f5169fe230b9fd92$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($f5169fe230b9fd92$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $f5169fe230b9fd92$var$getOtelParentSpanId(span),
            start_timestamp: $f5169fe230b9fd92$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $f5169fe230b9fd92$export$3f7581298f56c6d7(endTime) || undefined,
            status: $f5169fe230b9fd92$export$e238a77ea3a8cd66(status),
            op: attributes[0, $d58f778607a31700$export$1a413bd9a88fdb09],
            origin: attributes[0, $d58f778607a31700$export$cca8dd30f57f805e],
            links: $f5169fe230b9fd92$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
/**
 * Convert a span to the intermediate {@link StreamedSpanJSON} representation.
 */ function $f5169fe230b9fd92$export$db0cad9e44f67af8(span) {
    if ($f5169fe230b9fd92$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($f5169fe230b9fd92$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $f5169fe230b9fd92$var$getOtelParentSpanId(span),
            start_timestamp: $f5169fe230b9fd92$export$3f7581298f56c6d7(startTime),
            end_timestamp: $f5169fe230b9fd92$export$3f7581298f56c6d7(endTime),
            is_segment: span === $f5169fe230b9fd92$export$7a3106f345d83bb6(span),
            status: $f5169fe230b9fd92$export$457dcd3df4e9f5c6(status),
            attributes: attributes,
            links: $f5169fe230b9fd92$export$9015adcf158ef3a5(links)
        };
    }
    // Finally, as a fallback, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $f5169fe230b9fd92$export$7a3106f345d83bb6(span)
    };
}
/**
 * In preparation for the next major of OpenTelemetry, we want to support
 * looking up the parent span id according to the new API
 * In OTel v1, the parent span id is accessed as `parentSpanId`
 * In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
 */ function $f5169fe230b9fd92$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : undefined;
}
/**
 * Converts a {@link StreamedSpanJSON} to a {@link SerializedSpan}.
 * This is the final serialized span format that is sent to Sentry.
 * The returned serilaized spans must not be consumed by users or SDK integrations.
 */ function $f5169fe230b9fd92$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $1e978d8ec5f865cd$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $1e978d8ec5f865cd$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $f5169fe230b9fd92$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $f5169fe230b9fd92$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $f5169fe230b9fd92$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $f5169fe230b9fd92$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $f5169fe230b9fd92$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $2753bacab4d59770$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $2753bacab4d59770$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
/**
 * Convert the various statuses to the simple onces expected by Sentry for steamed spans ('ok' is default).
 */ function $f5169fe230b9fd92$export$457dcd3df4e9f5c6(status) {
    return !status || status.code === (0, $2753bacab4d59770$export$58f7963109c806fc) || status.code === (0, $2753bacab4d59770$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
const $f5169fe230b9fd92$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $f5169fe230b9fd92$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $f5169fe230b9fd92$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$f5169fe230b9fd92$var$ROOT_SPAN_FIELD] || span;
    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(childSpan, $f5169fe230b9fd92$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$f5169fe230b9fd92$var$CHILD_SPANS_FIELD]) span[$f5169fe230b9fd92$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(span, $f5169fe230b9fd92$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $f5169fe230b9fd92$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$f5169fe230b9fd92$var$CHILD_SPANS_FIELD]) span[$f5169fe230b9fd92$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $f5169fe230b9fd92$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($f5169fe230b9fd92$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$f5169fe230b9fd92$var$CHILD_SPANS_FIELD] ? Array.from(span[$f5169fe230b9fd92$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ const $f5169fe230b9fd92$export$c4c6a79b1260ca1b = $f5169fe230b9fd92$export$7a3106f345d83bb6;
/**
 * Returns the segment span of a given span.
 */ function $f5169fe230b9fd92$export$7a3106f345d83bb6(span) {
    return span[$f5169fe230b9fd92$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $f5169fe230b9fd92$export$1be426a8e585c83e() {
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const acs = (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $3642608fa82531c9$export$91f063ebb8eff307)((0, $23ec97ae524075cc$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $f5169fe230b9fd92$export$d11691ff45a3e535() {
    if (!$f5169fe230b9fd92$var$hasShownSpanDropWarning) {
        (0, $850185d9d2292f1a$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $f5169fe230b9fd92$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $f5169fe230b9fd92$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $d58f778607a31700$export$d7a7d984b0791405)]: "custom",
        [(0, $d58f778607a31700$export$165ce9a229f6f050)]: name
    });
}



const $788948895f3a5a61$export$849dbeeeda01ae98 = "production";
const $788948895f3a5a61$export$6829f580e78306fa = "development";










/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $1d0e535381dcc16c$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $1d0e535381dcc16c$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(spanWithMaybeDsc, $1d0e535381dcc16c$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $1d0e535381dcc16c$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $788948895f3a5a61$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $6224c48abfdf0275$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $1d0e535381dcc16c$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $1d0e535381dcc16c$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $1d0e535381dcc16c$export$a117f995597e25df(span) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $f5169fe230b9fd92$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $d58f778607a31700$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $d58f778607a31700$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$1d0e535381dcc16c$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $41d6d78bdb0c221c$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $1d0e535381dcc16c$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    // TODO(v11): Only read `SEMANTIC_ATTRIBUTE_SENTRY_SOURCE` again, once we renamed it to `sentry.span.source`
    const source = rootSpanAttributes[0, $d58f778607a31700$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.span.source"];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $0d56708971d86f7f$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $f5169fe230b9fd92$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $bad21278ffba8b28$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $1d0e535381dcc16c$export$95cf936fdacaff7b(span) {
    const dsc = $1d0e535381dcc16c$export$a117f995597e25df(span);
    return (0, $41d6d78bdb0c221c$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $9fd3c03998690751$export$2f3d84e767c9592b(span) {
    if (!(0, $4ffc93ad374b9e74$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $f5169fe230b9fd92$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $f5169fe230b9fd92$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $f5169fe230b9fd92$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $9fd3c03998690751$export$b77c830667a4d630(span) {
    if (!(0, $4ffc93ad374b9e74$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $f5169fe230b9fd92$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $850185d9d2292f1a$export$1c9f709888824e05).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $67a31a87afc17cfb$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $0d56708971d86f7f$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $eabe7a363b55f68b$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $044effeb1ee3c3cd$export$d6636b700b76c516 {
    /**
   * Reason why this span was dropped, if applicable ('ignored' or 'sample_rate').
   * Used to propagate the correct client report outcome to descendant spans
   * when span streaming is enabled.
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $259db5316e19a1fc$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $f5169fe230b9fd92$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}






/**
 * A wrapper to use the new span format in your `beforeSendSpan` callback.
 *
 * When using `traceLifecycle: 'stream'`, wrap your callback with this function
 * to receive and return {@link StreamedSpanJSON} instead of the standard {@link SpanJSON}.
 *
 * @example
 *
 * Sentry.init({
 *   traceLifecycle: 'stream',
 *   beforeSendSpan: withStreamedSpan((span) => {
 *     // span is of type StreamedSpanJSON
 *     return span;
 *   }),
 * });
 *
 * @param callback - The callback function that receives and returns a {@link StreamedSpanJSON}.
 * @returns A callback that is compatible with the `beforeSendSpan` option when using `traceLifecycle: 'stream'`.
 */ function $f7c9c832970bb79f$export$d3f49b33a1f44720(callback) {
    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
/**
 * Typesafe check to identify if a `beforeSendSpan` callback expects the streamed span JSON format.
 *
 * @param callback - The `beforeSendSpan` callback to check.
 * @returns `true` if the callback was wrapped with {@link withStreamedSpan}.
 */ function $f7c9c832970bb79f$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}







/**
 * Internal symbols for normalization behavior. JSON and other structured user payloads cannot
 * carry these keys, so they cannot spoof SDK-only normalization hints.
 * We use Symbol.for to ensure that the symbols are the same across different modules/files.
 */ const $84ce7a7e74304655$var$SENTRY_SKIP_NORMALIZATION = Symbol.for("sentry.skipNormalization");
const $84ce7a7e74304655$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = Symbol.for("sentry.overrideNormalizationDepth");
/** Marks an object so `normalize` returns it unchanged (already-normalized SDK data). */ function $84ce7a7e74304655$export$280812de8e91ea53(obj) {
    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(obj, $84ce7a7e74304655$var$SENTRY_SKIP_NORMALIZATION, true);
}
/** Overrides remaining normalization depth from this object downward (e.g. Redux / Pinia state). */ function $84ce7a7e74304655$export$610d1422c4bdc4c1(obj, depth) {
    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(obj, $84ce7a7e74304655$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
/** @internal */ function $84ce7a7e74304655$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$84ce7a7e74304655$var$SENTRY_SKIP_NORMALIZATION]);
}
/** @internal */ function $84ce7a7e74304655$export$fe95a19841c4b155(value) {
    const v = value[$84ce7a7e74304655$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : undefined;
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $225948f82235983d$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $225948f82235983d$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $225948f82235983d$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $225948f82235983d$export$a3295358bff77e(object, depth);
    if ($225948f82235983d$var$jsonSize(normalized) > maxSize) return $225948f82235983d$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $225948f82235983d$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $225948f82235983d$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $225948f82235983d$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. Hints use internal symbols
    // (see normalizationHints.ts) so user-controlled JSON cannot spoof them.
    if ((0, $84ce7a7e74304655$export$c8d26b7b28f926c7)(value)) return value;
    // Override remaining depth from this node (e.g. Redux / Pinia state). Set via setNormalizationDepthOverrideHint.
    const overrideDepth = (0, $84ce7a7e74304655$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== undefined ? overrideDepth : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $225948f82235983d$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $1bc3c607cc1507c7$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $225948f82235983d$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $225948f82235983d$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $e73c4a1df54c54bb$export$7916fad0ebc23f48)(value)) return (0, $b0bde6307b9dc37e$export$b6d9c5eb2330759f)(value);
        // React's SyntheticEvent thingy
        if ((0, $e73c4a1df54c54bb$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $b0bde6307b9dc37e$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $225948f82235983d$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $225948f82235983d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $225948f82235983d$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $225948f82235983d$var$jsonSize(value) {
    return $225948f82235983d$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $225948f82235983d$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $225948f82235983d$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $3c68b7f7745fd309$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $3c68b7f7745fd309$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $3c68b7f7745fd309$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $3c68b7f7745fd309$export$604a45d95a155e2b(envelope, types) {
    return $3c68b7f7745fd309$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $3c68b7f7745fd309$var$encodeUTF8(input) {
    const carrier = (0, $0dc2d2125eba808b$export$c8bfa33e4e8ae492)((0, $21592f648406440f$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $3c68b7f7745fd309$var$decodeUTF8(input) {
    const carrier = (0, $0dc2d2125eba808b$export$c8bfa33e4e8ae492)((0, $21592f648406440f$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $3c68b7f7745fd309$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $3c68b7f7745fd309$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $3c68b7f7745fd309$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $225948f82235983d$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $3c68b7f7745fd309$var$concatBuffers(parts);
}
function $3c68b7f7745fd309$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $3c68b7f7745fd309$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $3c68b7f7745fd309$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($3c68b7f7745fd309$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $3c68b7f7745fd309$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $3c68b7f7745fd309$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $3c68b7f7745fd309$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $3c68b7f7745fd309$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $3c68b7f7745fd309$var$_isOverriddenType(type) {
    return type in $3c68b7f7745fd309$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $3c68b7f7745fd309$export$b11169581eeaf237(type) {
    return $3c68b7f7745fd309$var$_isOverriddenType(type) ? $3c68b7f7745fd309$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $3c68b7f7745fd309$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $3c68b7f7745fd309$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6224c48abfdf0275$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $925ba57ae4f8f0a7$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $925ba57ae4f8f0a7$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $3c68b7f7745fd309$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6224c48abfdf0275$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $925ba57ae4f8f0a7$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $3c68b7f7745fd309$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $925ba57ae4f8f0a7$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $3c68b7f7745fd309$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $925ba57ae4f8f0a7$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $1d0e535381dcc16c$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6224c48abfdf0275$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $f5169fe230b9fd92$export$92d8c23565496537)(span);
        return !(0, $a00cd1cf06026f0b$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $f5169fe230b9fd92$export$92d8c23565496537)(span);
        const processedSpan = !(0, $f7c9c832970bb79f$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $f5169fe230b9fd92$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $f5169fe230b9fd92$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $3c68b7f7745fd309$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(headers, items);
}













/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $af4e7529fe29724a$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $f5169fe230b9fd92$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $d58f778607a31700$export$69cd5c610c7bb96a)]: value,
            [(0, $d58f778607a31700$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $af4e7529fe29724a$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $d58f778607a31700$export$f5f95cff026507b5];
        const value = attributes[0, $d58f778607a31700$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




/* eslint-disable max-lines */ const $58a8a7a768a379e5$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $58a8a7a768a379e5$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $259db5316e19a1fc$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $d58f778607a31700$export$cca8dd30f57f805e)]: "manual",
            [(0, $d58f778607a31700$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $f5169fe230b9fd92$export$eb571cd9b5d98de8) : (0, $f5169fe230b9fd92$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $f5169fe230b9fd92$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $d58f778607a31700$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $f5169fe230b9fd92$export$3f7581298f56c6d7)(endTimestamp);
        (0, $9fd3c03998690751$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $d58f778607a31700$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $f5169fe230b9fd92$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $d58f778607a31700$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $d58f778607a31700$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $d58f778607a31700$export$fea48ba9f4550879],
            measurements: (0, $af4e7529fe29724a$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $f5169fe230b9fd92$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(this),
            status: (0, $f5169fe230b9fd92$export$457dcd3df4e9f5c6)(this._status),
            attributes: this._attributes,
            links: (0, $f5169fe230b9fd92$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $58a8a7a768a379e5$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
        const attributes = $58a8a7a768a379e5$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $f5169fe230b9fd92$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            // Guarding sending standalone v1 spans as v2 streamed spans for now.
            // Otherwise they'd be sent once as v1 spans and again as streamed spans.
            // We'll migrate CLS and LCP spans to streamed spans in a later PR and
            // INP spans in the next major of the SDK. At that point, we can fully remove
            // standalone v1 spans <3
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $58a8a7a768a379e5$var$sendSpanEnvelope((0, $925ba57ae4f8f0a7$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        } else if (client && (0, $19ac0dd3041e6bff$export$6ea47215d699c04a)(client)) {
            // TODO (spans): Remove standalone span custom logic in favor of sending simple v2 web vital spans
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $bad21278ffba8b28$export$c08fbc656a245d03)(this).scope || (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$58a8a7a768a379e5$var$isFullFinishedSpan((0, $f5169fe230b9fd92$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $bad21278ffba8b28$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $f5169fe230b9fd92$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$58a8a7a768a379e5$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $f5169fe230b9fd92$export$92d8c23565496537)(span)).filter($58a8a7a768a379e5$var$isFullFinishedSpan);
        const source = this._attributes[0, $d58f778607a31700$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $d58f778607a31700$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $d58f778607a31700$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $f5169fe230b9fd92$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $58a8a7a768a379e5$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $58a8a7a768a379e5$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $1d0e535381dcc16c$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $af4e7529fe29724a$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $58a8a7a768a379e5$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $58a8a7a768a379e5$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $58a8a7a768a379e5$var$isStandaloneSpan(span) {
    return span instanceof $58a8a7a768a379e5$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $58a8a7a768a379e5$var$sendSpanEnvelope(envelope) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $3e191601acb89b03$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $3e191601acb89b03$export$a1bd95187356f372(options, callback) {
    const acs = $3e191601acb89b03$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $3e191601acb89b03$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $3e191601acb89b03$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
            const parentSpan = $3e191601acb89b03$var$getParentSpan(scope, customParentSpan);
            const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $044effeb1ee3c3cd$export$d6636b700b76c516)() : $3e191601acb89b03$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent("no_parent_span", "span");
            // Ignored root spans still need to be set on scope so that `getActiveSpan()` returns them
            // and descendants are also non-recording. Ignored child spans don't need this because
            // the parent span is already on scope.
            if (!$3e191601acb89b03$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $3642608fa82531c9$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e644c3f3fd5f6954$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $f5169fe230b9fd92$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $2753bacab4d59770$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $3e191601acb89b03$export$c10292ad04b92aea(options, callback) {
    const acs = $3e191601acb89b03$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $3e191601acb89b03$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $3e191601acb89b03$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
            const parentSpan = $3e191601acb89b03$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $044effeb1ee3c3cd$export$d6636b700b76c516)() : $3e191601acb89b03$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)()?.recordDroppedEvent("no_parent_span", "span");
            // We don't set ignored child spans onto the scope because there likely is an active,
            // unignored span on the scope already.
            if (!$3e191601acb89b03$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $3642608fa82531c9$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $e644c3f3fd5f6954$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $f5169fe230b9fd92$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $2753bacab4d59770$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $3e191601acb89b03$export$63dbba021a6b4047(options) {
    const acs = $3e191601acb89b03$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $3e191601acb89b03$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $23ec97ae524075cc$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$3e191601acb89b03$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
        const parentSpan = $3e191601acb89b03$var$getParentSpan(scope, customParentSpan);
        const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent("no_parent_span", "span");
            return new (0, $044effeb1ee3c3cd$export$d6636b700b76c516)();
        }
        return $3e191601acb89b03$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $3e191601acb89b03$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    const acs = (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $41d6d78bdb0c221c$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $95469603e83f0479$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $3e191601acb89b03$export$f90b03291402f553(callback);
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $95469603e83f0479$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $3642608fa82531c9$export$3f25fa50c18e20ca)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $3e191601acb89b03$export$e57ac09b143d92a2(span, callback) {
    const acs = $3e191601acb89b03$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)((scope)=>{
        (0, $3642608fa82531c9$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $3e191601acb89b03$export$869298f9835abc68(callback) {
    const acs = $3e191601acb89b03$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$3e191601acb89b03$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$3e191601acb89b03$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $3e191601acb89b03$export$f90b03291402f553(callback) {
    const acs = $3e191601acb89b03$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $259db5316e19a1fc$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $f8b69a19c3af2f20$export$9869d72de32a3917)()
        });
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $3e191601acb89b03$export$e57ac09b143d92a2(null, callback);
    });
}
function $3e191601acb89b03$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $0d56708971d86f7f$export$1f70765132c3c225)()) {
        const span = new (0, $044effeb1ee3c3cd$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $1d0e535381dcc16c$export$a117f995597e25df)(span)
            };
            (0, $1d0e535381dcc16c$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if ($3e191601acb89b03$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$3e191601acb89b03$var$_isTracingSuppressed(scope)) // if tracing is actively suppressed (Sentry.suppressTracing(...)),
        // we don't want to record a client outcome for the ignored span
        client?.recordDroppedEvent("ignored", "span");
        return new (0, $044effeb1ee3c3cd$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $3e191601acb89b03$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $f5169fe230b9fd92$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $1d0e535381dcc16c$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $f5169fe230b9fd92$export$5caecac1caaf3a71)(parentSpan);
        span = $3e191601acb89b03$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $1d0e535381dcc16c$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $3e191601acb89b03$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $1d0e535381dcc16c$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $9fd3c03998690751$export$2f3d84e767c9592b)(span);
    (0, $bad21278ffba8b28$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $3e191601acb89b03$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $f5169fe230b9fd92$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $3e191601acb89b03$var$getAcs() {
    const carrier = (0, $0dc2d2125eba808b$export$19eade501500c6c1)();
    return (0, $4c55c7af4f9581a9$export$f639b0c2752203be)(carrier);
}
function $3e191601acb89b03$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $3e191601acb89b03$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, $67a31a87afc17cfb$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $eabe7a363b55f68b$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $58a8a7a768a379e5$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $d58f778607a31700$export$d7a7d984b0791405)]: "custom",
            [(0, $d58f778607a31700$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $19ac0dd3041e6bff$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $3e191601acb89b03$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $3e191601acb89b03$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, $f5169fe230b9fd92$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $58a8a7a768a379e5$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $044effeb1ee3c3cd$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $f5169fe230b9fd92$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $19ac0dd3041e6bff$export$6ea47215d699c04a)(client) && childSpan instanceof (0, $044effeb1ee3c3cd$export$d6636b700b76c516)) {
        if (parentSpan instanceof (0, $044effeb1ee3c3cd$export$d6636b700b76c516) && parentSpan.dropReason) {
            // We land here if the parent span was a segment span that was ignored (`ignoreSpans`).
            // In this case, the child was also ignored (see `sampled` above) but we need to
            // record a client outcome for the child.
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!isTracingSuppressed) {
            // Otherwise, the child is not sampled due to sampling of the parent span,
            // hence we record a sample_rate client outcome for the child.
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $3e191601acb89b03$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $3642608fa82531c9$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $3e191601acb89b03$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $3e191601acb89b03$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
/* Checks if `ignoreSpans` applies (extracted for bundle size)*/ function $3e191601acb89b03$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $19ac0dd3041e6bff$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $a00cd1cf06026f0b$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $d58f778607a31700$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $3e191601acb89b03$var$_isIgnoredSpan(span) {
    return span instanceof (0, $044effeb1ee3c3cd$export$d6636b700b76c516) && span.dropReason === "ignored";
}
function $3e191601acb89b03$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$3e191601acb89b03$var$SUPPRESS_TRACING_KEY] === true;
}










/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $9db83356a1ec17d5$var$STATE_PENDING = 0;
const $9db83356a1ec17d5$var$STATE_RESOLVED = 1;
const $9db83356a1ec17d5$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9db83356a1ec17d5$export$1fda8aa4d135f8aa(value) {
    return new $9db83356a1ec17d5$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9db83356a1ec17d5$export$78e43115b553f358(reason) {
    return new $9db83356a1ec17d5$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9db83356a1ec17d5$export$6f292d4960313241 {
    constructor(executor){
        this._state = $9db83356a1ec17d5$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9db83356a1ec17d5$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9db83356a1ec17d5$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9db83356a1ec17d5$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9db83356a1ec17d5$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $9db83356a1ec17d5$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9db83356a1ec17d5$var$STATE_PENDING) return;
            if ((0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9db83356a1ec17d5$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9db83356a1ec17d5$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $e8c8b3d06aa8256b$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $e8c8b3d06aa8256b$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(result) ? result : (0, $9db83356a1ec17d5$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $9db83356a1ec17d5$export$78e43115b553f358)(error);
    }
}
function $e8c8b3d06aa8256b$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && result === null && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Event processor "${processor.id || "?"}" dropped event`);
    if ((0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(result)) return result.then((final)=>$e8c8b3d06aa8256b$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $e8c8b3d06aa8256b$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $201569bccb6b7457$var$parsedStackResults;
let $201569bccb6b7457$var$lastSentryKeysCount;
let $201569bccb6b7457$var$lastNativeKeysCount;
let $201569bccb6b7457$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $201569bccb6b7457$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $21592f648406440f$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $21592f648406440f$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($201569bccb6b7457$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $201569bccb6b7457$var$lastSentryKeysCount && nativeDebugIdKeys.length === $201569bccb6b7457$var$lastNativeKeysCount) return $201569bccb6b7457$var$cachedFilenameDebugIds;
    $201569bccb6b7457$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $201569bccb6b7457$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $201569bccb6b7457$var$cachedFilenameDebugIds = {};
    if (!$201569bccb6b7457$var$parsedStackResults) $201569bccb6b7457$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $201569bccb6b7457$var$parsedStackResults?.[key];
            if (result && $201569bccb6b7457$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $201569bccb6b7457$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($201569bccb6b7457$var$parsedStackResults) $201569bccb6b7457$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $201569bccb6b7457$var$cachedFilenameDebugIds && $201569bccb6b7457$var$parsedStackResults) {
                        $201569bccb6b7457$var$cachedFilenameDebugIds[filename] = debugId;
                        $201569bccb6b7457$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $201569bccb6b7457$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $201569bccb6b7457$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $201569bccb6b7457$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $b0bde6307b9dc37e$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}








/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $d8f548fa6f8327a6$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $d8f548fa6f8327a6$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $d8f548fa6f8327a6$var$applySpanToEvent(event, span);
    $d8f548fa6f8327a6$var$applyFingerprintToEvent(event, fingerprint);
    $d8f548fa6f8327a6$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $d8f548fa6f8327a6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $d8f548fa6f8327a6$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $d8f548fa6f8327a6$export$b1a120a2871faa46(data, "extra", extra);
    $d8f548fa6f8327a6$export$b1a120a2871faa46(data, "tags", tags);
    $d8f548fa6f8327a6$export$b1a120a2871faa46(data, "attributes", attributes);
    $d8f548fa6f8327a6$export$b1a120a2871faa46(data, "user", user);
    $d8f548fa6f8327a6$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $86056d80eaaa46ab$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $d8f548fa6f8327a6$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $86056d80eaaa46ab$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $d8f548fa6f8327a6$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $23ec97ae524075cc$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $d8f548fa6f8327a6$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $d8f548fa6f8327a6$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $d8f548fa6f8327a6$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $d8f548fa6f8327a6$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $d8f548fa6f8327a6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $d8f548fa6f8327a6$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $f5169fe230b9fd92$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $1d0e535381dcc16c$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $f5169fe230b9fd92$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $f5169fe230b9fd92$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $d8f548fa6f8327a6$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}





/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $dbaab99f2a9a12d0$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $c50b6b986a937e54$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $9a227e6c9c778209$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $dbaab99f2a9a12d0$export$d7e04067a6fbc882(prepared, options);
    $dbaab99f2a9a12d0$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $dbaab99f2a9a12d0$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $dbaab99f2a9a12d0$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $d8f548fa6f8327a6$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $d8f548fa6f8327a6$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $9db83356a1ec17d5$export$1fda8aa4d135f8aa)(prepared) : (0, $e8c8b3d06aa8256b$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $dbaab99f2a9a12d0$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $dbaab99f2a9a12d0$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $dbaab99f2a9a12d0$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $788948895f3a5a61$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $937c50c58c7016cb$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = (0, $937c50c58c7016cb$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $dbaab99f2a9a12d0$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $201569bccb6b7457$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $dbaab99f2a9a12d0$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $dbaab99f2a9a12d0$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $dbaab99f2a9a12d0$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $225948f82235983d$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $225948f82235983d$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $225948f82235983d$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $225948f82235983d$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $225948f82235983d$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $225948f82235983d$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $225948f82235983d$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $dbaab99f2a9a12d0$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $a7665540edab3cc5$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $dbaab99f2a9a12d0$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($dbaab99f2a9a12d0$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($dbaab99f2a9a12d0$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $dbaab99f2a9a12d0$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $a7665540edab3cc5$export$775b6bb06e53a214) || typeof hint === "function";
}
const $dbaab99f2a9a12d0$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $dbaab99f2a9a12d0$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$dbaab99f2a9a12d0$var$captureContextKeys.includes(key));
}





/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $c3e9201918a8fd27$export$f5282963edea4a68(exception, hint) {
    return (0, $23ec97ae524075cc$export$c7be4b0125a10cba)().captureException(exception, (0, $dbaab99f2a9a12d0$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $c3e9201918a8fd27$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $23ec97ae524075cc$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $c3e9201918a8fd27$export$1462b974fdcf6ba2(event, hint) {
    return (0, $23ec97ae524075cc$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $c3e9201918a8fd27$export$2f04de43fe27971a(name, context) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $c3e9201918a8fd27$export$bb4922da0dd51b92(extras) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $c3e9201918a8fd27$export$8e8e7789d42ed61d(key, extra) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $c3e9201918a8fd27$export$74a8fb34822092e6(tags) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $c3e9201918a8fd27$export$a37d07ee78eb4569(key, value) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $c3e9201918a8fd27$export$8b6bb3dd62a01be2(user) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $c3e9201918a8fd27$export$58213391a19e392(conversationId) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $c3e9201918a8fd27$export$5d4e9fd7fac8e617() {
    return (0, $23ec97ae524075cc$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c3e9201918a8fd27$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $c50b6b986a937e54$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c3e9201918a8fd27$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $c3e9201918a8fd27$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $c3e9201918a8fd27$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    return (0, $23ec97ae524075cc$export$9a4fed82c350c2bd)(()=>upsertMonitorConfig?.isolateTrace ? (0, $3e191601acb89b03$export$f90b03291402f553)(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c3e9201918a8fd27$export$4909b86c8034bf73(timeout) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c3e9201918a8fd27$export$8360e631d277ea4d(timeout) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $c3e9201918a8fd27$export$3f95c6f800b78024() {
    return !!(0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $c3e9201918a8fd27$export$3b029eb57ac4d562() {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $c3e9201918a8fd27$export$9aac0b9f77928fbf(callback) {
    (0, $23ec97ae524075cc$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $c3e9201918a8fd27$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)();
    const { user: user } = (0, $d8f548fa6f8327a6$export$cc422922fcbb91c6)(isolationScope, (0, $23ec97ae524075cc$export$c7be4b0125a10cba)());
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $21592f648406440f$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $e2b7371c0209d323$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $e2b7371c0209d323$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $c3e9201918a8fd27$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $c3e9201918a8fd27$export$17a5be43989a0bc1() {
    const isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)();
    const currentScope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e2b7371c0209d323$export$56521d9ba90f62ee)(session);
    $c3e9201918a8fd27$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $c3e9201918a8fd27$var$_sendSessionUpdate() {
    const isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)();
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $c3e9201918a8fd27$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $c3e9201918a8fd27$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $c3e9201918a8fd27$var$_sendSessionUpdate();
}





const $d9cad6cf2ba3b190$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $d9cad6cf2ba3b190$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $d9cad6cf2ba3b190$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $d9cad6cf2ba3b190$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $d9cad6cf2ba3b190$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $d9cad6cf2ba3b190$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $d9cad6cf2ba3b190$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $d9cad6cf2ba3b190$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$d9cad6cf2ba3b190$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $d9cad6cf2ba3b190$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") // The cast is needed because TS can't resolve overloads when the discriminant is a union type.
        // Both overloads have the same callback signature so this is safe.
        client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $d9cad6cf2ba3b190$export$2d8f5188773bcddd(integration) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $d9cad6cf2ba3b190$export$2323046b9414659f(fn) {
    return fn;
}




const $5646b2aebec8f115$var$INTEGRATION_NAME = "ConversationId";
const $5646b2aebec8f115$var$_conversationIdIntegration = ()=>{
    return {
        name: $5646b2aebec8f115$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $23ec97ae524075cc$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = (0, $f5169fe230b9fd92$export$92d8c23565496537)(span);
                    // Only apply conversation ID to gen_ai spans.
                    // We also check for Vercel AI spans (ai.operationId attribute or ai.* span name)
                    // because the Vercel AI integration sets the gen_ai.* op in its own spanStart handler
                    // which fires after this, so the op is not yet available at this point.
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute((0, $d58f778607a31700$export$71a4a707257f2774), conversationId);
                }
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $5646b2aebec8f115$export$97457a453081a5b3 = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($5646b2aebec8f115$var$_conversationIdIntegration);





const $00d0862ab0be797e$var$INTEGRATION_NAME = "Dedupe";
const $00d0862ab0be797e$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $00d0862ab0be797e$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($00d0862ab0be797e$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $00d0862ab0be797e$export$6d39aa44cd0c7567 = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($00d0862ab0be797e$var$_dedupeIntegration);
/** only exported for tests. */ function $00d0862ab0be797e$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($00d0862ab0be797e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($00d0862ab0be797e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $00d0862ab0be797e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$00d0862ab0be797e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$00d0862ab0be797e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $00d0862ab0be797e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $00d0862ab0be797e$var$_getExceptionFromEvent(previousEvent);
    const currentException = $00d0862ab0be797e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$00d0862ab0be797e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$00d0862ab0be797e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $00d0862ab0be797e$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $b0bde6307b9dc37e$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $b0bde6307b9dc37e$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $00d0862ab0be797e$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $00d0862ab0be797e$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}




let $7ecb5c803da9ca0f$var$originalFunctionToString;
const $7ecb5c803da9ca0f$var$INTEGRATION_NAME = "FunctionToString";
const $7ecb5c803da9ca0f$var$SETUP_CLIENTS = new WeakMap();
const $7ecb5c803da9ca0f$var$_functionToStringIntegration = ()=>{
    return {
        name: $7ecb5c803da9ca0f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7ecb5c803da9ca0f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $1bc3c607cc1507c7$export$e6cc1e135e2092e5)(this);
                    const context = $7ecb5c803da9ca0f$var$SETUP_CLIENTS.has((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7ecb5c803da9ca0f$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7ecb5c803da9ca0f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7ecb5c803da9ca0f$export$7918117e9202e4fb = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($7ecb5c803da9ca0f$var$_functionToStringIntegration);




/**
 * Get a list of possible event messages from a Sentry event.
 */ function $1ec63eda5f0cf062$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $235934cdeac6e652$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $235934cdeac6e652$var$INTEGRATION_NAME = "EventFilters";
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $235934cdeac6e652$export$9a84f518c163c552 = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $235934cdeac6e652$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $235934cdeac6e652$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $235934cdeac6e652$var$_mergeOptions(options, clientOptions);
            }
            return $235934cdeac6e652$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $235934cdeac6e652$export$cb3c5c2ceb9818ba = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)((options = {})=>{
    return {
        ...$235934cdeac6e652$export$9a84f518c163c552(options),
        name: "InboundFilters"
    };
});
function $235934cdeac6e652$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $235934cdeac6e652$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $235934cdeac6e652$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($235934cdeac6e652$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $c50b6b986a937e54$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($235934cdeac6e652$var$_isUselessError(event)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $c50b6b986a937e54$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($235934cdeac6e652$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $c50b6b986a937e54$export$4157119e2b157127)(event)}.\nUrl: ${$235934cdeac6e652$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$235934cdeac6e652$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $c50b6b986a937e54$export$4157119e2b157127)(event)}.\nUrl: ${$235934cdeac6e652$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") // Filter transactions
    {
        if ($235934cdeac6e652$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $c50b6b986a937e54$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $235934cdeac6e652$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $1ec63eda5f0cf062$export$d55a97c329cacfcc)(event).some((message)=>(0, $937c50c58c7016cb$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $235934cdeac6e652$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $937c50c58c7016cb$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $235934cdeac6e652$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $235934cdeac6e652$var$_getEventFilterUrl(event);
    return !url ? false : (0, $937c50c58c7016cb$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $235934cdeac6e652$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $235934cdeac6e652$var$_getEventFilterUrl(event);
    return !url ? true : (0, $937c50c58c7016cb$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $235934cdeac6e652$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $235934cdeac6e652$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $235934cdeac6e652$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $c50b6b986a937e54$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $235934cdeac6e652$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $7f8e7288e0907ec2$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $4ffc93ad374b9e74$export$16a28057038b10ef) (0, $850185d9d2292f1a$export$1c9f709888824e05).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $850185d9d2292f1a$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $7f8e7288e0907ec2$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $7f8e7288e0907ec2$export$ecb76f41d43c0e43(client) {
    (0, $23ec97ae524075cc$export$c7be4b0125a10cba)().setClient(client);
}











const $65680e085c139003$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $65680e085c139003$var$_sequenceNumber = 0;
let $65680e085c139003$var$_previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function $65680e085c139003$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if ($65680e085c139003$var$_previousTimestampMs !== undefined && nowMs !== $65680e085c139003$var$_previousTimestampMs) $65680e085c139003$var$_sequenceNumber = 0;
    const value = $65680e085c139003$var$_sequenceNumber;
    $65680e085c139003$var$_sequenceNumber++;
    $65680e085c139003$var$_previousTimestampMs = nowMs;
    return {
        key: $65680e085c139003$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}





/** Extract trace information from scope */ function $4062c0738fe063aa$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $23ec97ae524075cc$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $f5169fe230b9fd92$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $f5169fe230b9fd92$export$46c6fbd1d265ebf0)(span) : (0, $23ec97ae524075cc$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $1d0e535381dcc16c$export$a117f995597e25df)(span) : (0, $1d0e535381dcc16c$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $a9a1b9400c7db2b6$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $d4d79508e8342812$export$efdf3b13edb1118e(items) {
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $d4d79508e8342812$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $6224c48abfdf0275$export$44d472fbb931a776)(dsn);
    return (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(headers, [
        $d4d79508e8342812$export$efdf3b13edb1118e(logs)
    ]);
}


const $7550689fe8efd1a0$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $7550689fe8efd1a0$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $7550689fe8efd1a0$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $7550689fe8efd1a0$var$_getBufferMap();
    const logBuffer = $7550689fe8efd1a0$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $7550689fe8efd1a0$var$MAX_LOG_BUFFER_SIZE) {
        $7550689fe8efd1a0$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $7550689fe8efd1a0$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)(), captureSerializedLog = $7550689fe8efd1a0$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, $4062c0738fe063aa$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $d8f548fa6f8327a6$export$cc422922fcbb91c6)((0, $23ec97ae524075cc$export$68f3af03034c9e90)(), currentScope);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $e73c4a1df54c54bb$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $3642608fa82531c9$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $7550689fe8efd1a0$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $850185d9d2292f1a$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $65680e085c139003$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $a9a1b9400c7db2b6$export$4fb50c0840d636d1)[level],
        attributes: {
            ...(0, $1e978d8ec5f865cd$export$4954cae66e755861)(scopeAttributes),
            ...(0, $1e978d8ec5f865cd$export$4954cae66e755861)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $7550689fe8efd1a0$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $7550689fe8efd1a0$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $d4d79508e8342812$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $7550689fe8efd1a0$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $7550689fe8efd1a0$export$5365c9902fb9e770(client) {
    return $7550689fe8efd1a0$var$_getBufferMap().get(client);
}
function $7550689fe8efd1a0$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $0dc2d2125eba808b$export$7e223ec222791509)("clientToLogBufferMap", ()=>new WeakMap());
}













/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function $0ed65df02ec38772$export$58e45eb52ad1077d(items) {
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $0ed65df02ec38772$export$f23eb96e33154901(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $6224c48abfdf0275$export$44d472fbb931a776)(dsn);
    return (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(headers, [
        $0ed65df02ec38772$export$58e45eb52ad1077d(metrics)
    ]);
}


const $751c742c1adfc903$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $751c742c1adfc903$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $751c742c1adfc903$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $751c742c1adfc903$var$_getBufferMap();
    const metricBuffer = $751c742c1adfc903$export$49385134251b08ff(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $751c742c1adfc903$var$MAX_METRIC_BUFFER_SIZE) {
        $751c742c1adfc903$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $751c742c1adfc903$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    // Add Sentry metadata
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    // Add replay metadata
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $751c742c1adfc903$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $751c742c1adfc903$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = (0, $4062c0738fe063aa$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $3642608fa82531c9$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = (0, $9a227e6c9c778209$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $65680e085c139003$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $1e978d8ec5f865cd$export$4954cae66e755861)(scopeAttributes),
            ...(0, $1e978d8ec5f865cd$export$4954cae66e755861)(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $751c742c1adfc903$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $23ec97ae524075cc$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $751c742c1adfc903$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = (0, $d8f548fa6f8327a6$export$cc422922fcbb91c6)((0, $23ec97ae524075cc$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $751c742c1adfc903$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $751c742c1adfc903$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $751c742c1adfc903$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $751c742c1adfc903$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $0ed65df02ec38772$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    $751c742c1adfc903$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $751c742c1adfc903$export$49385134251b08ff(client) {
    return $751c742c1adfc903$var$_getBufferMap().get(client);
}
function $751c742c1adfc903$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, $0dc2d2125eba808b$export$7e223ec222791509)("clientToMetricBufferMap", ()=>new WeakMap());
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $0e6458868d27d165$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
/**
 * @internal
 */ function $0e6458868d27d165$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === undefined) session.ipAddress = "{{auto}}";
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $8c49af227632e107$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c)
            }));
        sdk.version = (0, $ecf2bd8eabf48f5f$export$31499a9cd224b78c);
    }
}


const $480fea30b1ea5d5e$export$9207631ea4ce5c48 = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $480fea30b1ea5d5e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $480fea30b1ea5d5e$var$_getIngestEndpoint(dsn) {
    return `${$480fea30b1ea5d5e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $480fea30b1ea5d5e$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $480fea30b1ea5d5e$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $480fea30b1ea5d5e$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$480fea30b1ea5d5e$var$_getIngestEndpoint(dsn)}?${$480fea30b1ea5d5e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $480fea30b1ea5d5e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $6224c48abfdf0275$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$480fea30b1ea5d5e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $6224c48abfdf0275$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
















/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ function $1590461dc0fd29f2$export$630056cb83d87863(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}


const $b01da0ce7a78cb97$export$c8667f1887a128dc = Symbol.for("SentryBufferFullError");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $b01da0ce7a78cb97$export$85a4f67f852183e6(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9db83356a1ec17d5$export$78e43115b553f358)($b01da0ce7a78cb97$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, $9db83356a1ec17d5$export$1fda8aa4d135f8aa)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $1590461dc0fd29f2$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $80e273ee4dd6b189$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $80e273ee4dd6b189$export$615352e17ed7741(header, now = (0, $f8b69a19c3af2f20$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $80e273ee4dd6b189$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $80e273ee4dd6b189$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $80e273ee4dd6b189$export$6c91fec22056810a(limits, dataCategory, now = (0, $f8b69a19c3af2f20$export$65b1bada40c91b34)()) {
    return $80e273ee4dd6b189$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $80e273ee4dd6b189$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $f8b69a19c3af2f20$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $80e273ee4dd6b189$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $a94c66d3fd60f683$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $a94c66d3fd60f683$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $b01da0ce7a78cb97$export$85a4f67f852183e6)(options.bufferSize || $a94c66d3fd60f683$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $3c68b7f7745fd309$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $3c68b7f7745fd309$export$b11169581eeaf237)(type);
            if ((0, $80e273ee4dd6b189$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ((0, $3c68b7f7745fd309$export$604a45d95a155e2b)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $3c68b7f7745fd309$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $3c68b7f7745fd309$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $3c68b7f7745fd309$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ((0, $4ffc93ad374b9e74$export$16a28057038b10ef) && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $80e273ee4dd6b189$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $b01da0ce7a78cb97$export$c8667f1887a128dc)) {
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $29cc6b60dad5a347$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $9a227e6c9c778209$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $3c68b7f7745fd309$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


















/**
 * Converts a transaction event to a span JSON object.
 */ function $6a59001ef075fe3a$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $d58f778607a31700$export$1efec95406bbe327],
        exclusive_time: data?.[0, $d58f778607a31700$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $6a59001ef075fe3a$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $d58f778607a31700$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $d58f778607a31700$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $407a44de521243bb$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $407a44de521243bb$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $407a44de521243bb$var$INTERNAL_ERROR_SYMBOL = Symbol.for("SentryInternalError");
const $407a44de521243bb$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for("SentryDoNotSendEventError");
// Default interval for flushing logs and metrics (5 seconds)
const $407a44de521243bb$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $407a44de521243bb$var$_makeInternalError(message) {
    return {
        message: message,
        [$407a44de521243bb$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $407a44de521243bb$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$407a44de521243bb$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $407a44de521243bb$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $407a44de521243bb$var$INTERNAL_ERROR_SYMBOL in error;
}
function $407a44de521243bb$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $407a44de521243bb$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $407a44de521243bb$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = (0, $1590461dc0fd29f2$export$630056cb83d87863)(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $407a44de521243bb$var$DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $407a44de521243bb$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $b01da0ce7a78cb97$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $a94c66d3fd60f683$export$e515cf6dfd2f98b8));
        if (options.dsn) this._dsn = (0, $6224c48abfdf0275$export$128827c3562ec0cb)(options.dsn);
        else (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $480fea30b1ea5d5e$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $407a44de521243bb$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $407a44de521243bb$var$estimateLogSizeInBytes, (0, $7550689fe8efd1a0$export$f8ed83d3b6a0b504));
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $407a44de521243bb$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $407a44de521243bb$var$estimateMetricSizeInBytes, (0, $751c742c1adfc903$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $c50b6b986a937e54$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $c50b6b986a937e54$export$6de4ffac6a2f1098)(exception)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log($407a44de521243bb$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $c50b6b986a937e54$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $e73c4a1df54c54bb$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $e73c4a1df54c54bb$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $c50b6b986a937e54$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $c50b6b986a937e54$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log($407a44de521243bb$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $407a44de521243bb$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $e2b7371c0209d323$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit("flush");
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        (0, $7550689fe8efd1a0$export$f8ed83d3b6a0b504)(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        // This hook takes care of only installing if not already installed
        (0, $d9cad6cf2ba3b190$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $d9cad6cf2ba3b190$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $925ba57ae4f8f0a7$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $3c68b7f7745fd309$export$d650323442802f6f)(env, (0, $3c68b7f7745fd309$export$d8fc80952cc31fa4)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $788948895f3a5a61$export$849dbeeeda01ae98) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn($407a44de521243bb$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn($407a44de521243bb$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $925ba57ae4f8f0a7$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error("Error while sending envelope:", reason);
            return {};
        }
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {
    // No-op in base class - subclasses override to implement cleanup registration
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $d9cad6cf2ba3b190$export$51abed9797baa598)(this, integrations);
        (0, $d9cad6cf2ba3b190$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e2b7371c0209d323$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $dbaab99f2a9a12d0$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $23ec97ae524075cc$export$1e83db7ee4876dc4)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $1d0e535381dcc16c$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $23ec97ae524075cc$export$c7be4b0125a10cba)(), isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)()) {
        if ((0, $4ffc93ad374b9e74$export$16a28057038b10ef) && $407a44de521243bb$var$isErrorEvent(event)) (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Captured error event \`${(0, $1ec63eda5f0cf062$export$d55a97c329cacfcc)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $4ffc93ad374b9e74$export$16a28057038b10ef) {
                if ($407a44de521243bb$var$_isDoNotSendEventError(reason)) (0, $850185d9d2292f1a$export$1c9f709888824e05).log(reason.message);
                else if ($407a44de521243bb$var$_isInternalError(reason)) (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(reason.message);
                else (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $407a44de521243bb$var$isTransactionEvent(event);
        const isError = $407a44de521243bb$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $eabe7a363b55f68b$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && (0, $f8b69a19c3af2f20$export$9869d72de32a3917)() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, $9db83356a1ec17d5$export$78e43115b553f358)($407a44de521243bb$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $407a44de521243bb$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $407a44de521243bb$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $407a44de521243bb$var$processBeforeSend(this, options, prepared, hint);
            return $407a44de521243bb$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $407a44de521243bb$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($407a44de521243bb$var$_isDoNotSendEventError(reason) || $407a44de521243bb$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $407a44de521243bb$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $b01da0ce7a78cb97$export$c8667f1887a128dc)) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log("Sending outcomes:", outcomes);
        const envelope = (0, $29cc6b60dad5a347$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $6224c48abfdf0275$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $407a44de521243bb$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $407a44de521243bb$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $e73c4a1df54c54bb$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $e73c4a1df54c54bb$export$53b83ca8eaab0383)(event) && event !== null) throw $407a44de521243bb$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $407a44de521243bb$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $e73c4a1df54c54bb$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $407a44de521243bb$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $407a44de521243bb$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan = !(0, $f7c9c832970bb79f$export$ca3e1ec3cdcc76ac)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($407a44de521243bb$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($407a44de521243bb$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $6a59001ef075fe3a$export$d9c6b2464b0a687e)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, $a00cd1cf06026f0b$export$5d569ac97c389400)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $f5169fe230b9fd92$export$d11691ff45a3e535)();
                else // update event with processed root span values
                processedEvent = (0, $86056d80eaaa46ab$export$4950aa0f605343fb)(event, (0, $6a59001ef075fe3a$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, $a00cd1cf06026f0b$export$5d569ac97c389400)({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        (0, $a00cd1cf06026f0b$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $f5169fe230b9fd92$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $407a44de521243bb$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $407a44de521243bb$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $407a44de521243bb$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $407a44de521243bb$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $407a44de521243bb$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $407a44de521243bb$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $407a44de521243bb$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $407a44de521243bb$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $e73c4a1df54c54bb$export$c3825b437cbdea5c)(value)) weight += $407a44de521243bb$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $407a44de521243bb$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $efb742987ee4a3aa$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $efb742987ee4a3aa$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}






/**
 * Extracts stack frames from the error.stack string
 */ function $d659a3ed21de6bba$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $d659a3ed21de6bba$var$hasSentryFetchUrlHost(error) {
    return (0, $e73c4a1df54c54bb$export$e6127cc7fe7395c3)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $d659a3ed21de6bba$export$35a730c8874c1024(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($d659a3ed21de6bba$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $d659a3ed21de6bba$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $d659a3ed21de6bba$export$35a730c8874c1024(error)
    };
    const frames = $d659a3ed21de6bba$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $d659a3ed21de6bba$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $d659a3ed21de6bba$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = (0, $1bc3c607cc1507c7$export$b0244d5063c0b61b)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $e73c4a1df54c54bb$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $d659a3ed21de6bba$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $d659a3ed21de6bba$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $d659a3ed21de6bba$var$getException(client, mechanism, exception, hint) {
    if ((0, $e73c4a1df54c54bb$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, $e73c4a1df54c54bb$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: (0, $225948f82235983d$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $d659a3ed21de6bba$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $d659a3ed21de6bba$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $d659a3ed21de6bba$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $d659a3ed21de6bba$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $d659a3ed21de6bba$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $c50b6b986a937e54$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $d659a3ed21de6bba$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $d659a3ed21de6bba$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $e73c4a1df54c54bb$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


/**
 * This function creates an exception from a JavaScript Error
 */ function $354f6ad152059a8c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $354f6ad152059a8c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $354f6ad152059a8c$export$2e9ae379995d99e3(ex),
        value: $354f6ad152059a8c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $354f6ad152059a8c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $354f6ad152059a8c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $225948f82235983d$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $354f6ad152059a8c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $e73c4a1df54c54bb$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $354f6ad152059a8c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $354f6ad152059a8c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $354f6ad152059a8c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $354f6ad152059a8c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $354f6ad152059a8c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $354f6ad152059a8c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $354f6ad152059a8c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $354f6ad152059a8c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $354f6ad152059a8c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $354f6ad152059a8c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $354f6ad152059a8c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $354f6ad152059a8c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    // oxlint-disable-next-line typescript/prefer-optional-chain
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $354f6ad152059a8c$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $354f6ad152059a8c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $354f6ad152059a8c$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($354f6ad152059a8c$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $d659a3ed21de6bba$export$35a730c8874c1024)(message.error);
    return (0, $d659a3ed21de6bba$export$35a730c8874c1024)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $354f6ad152059a8c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $354f6ad152059a8c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9db83356a1ec17d5$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $354f6ad152059a8c$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $354f6ad152059a8c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9db83356a1ec17d5$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $354f6ad152059a8c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $e73c4a1df54c54bb$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $354f6ad152059a8c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $e73c4a1df54c54bb$export$ef9e2056653f0c8e)(exception) || (0, $e73c4a1df54c54bb$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $354f6ad152059a8c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $e73c4a1df54c54bb$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $354f6ad152059a8c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $c50b6b986a937e54$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $e73c4a1df54c54bb$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $354f6ad152059a8c$var$eventFromError(stackParser, exception);
    if ((0, $e73c4a1df54c54bb$export$53b83ca8eaab0383)(exception) || (0, $e73c4a1df54c54bb$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $354f6ad152059a8c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $354f6ad152059a8c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $c50b6b986a937e54$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $354f6ad152059a8c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $354f6ad152059a8c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $e73c4a1df54c54bb$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $354f6ad152059a8c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $1bc3c607cc1507c7$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $e73c4a1df54c54bb$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $e73c4a1df54c54bb$export$9671ea99bd126ace)(exception)) {
        const className = $354f6ad152059a8c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $354f6ad152059a8c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $354f6ad152059a8c$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



const $2180f0e9ff5dad08$export$56d8a8a25bd48b81 = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
let $2180f0e9ff5dad08$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $2180f0e9ff5dad08$export$b79738ab10c590b2() {
    return $2180f0e9ff5dad08$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $2180f0e9ff5dad08$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $2180f0e9ff5dad08$var$ignoreOnError++;
    setTimeout(()=>{
        $2180f0e9ff5dad08$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $2180f0e9ff5dad08$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $1bc3c607cc1507c7$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$2180f0e9ff5dad08$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $2180f0e9ff5dad08$export$1265a142ff5ba165();
            (0, $23ec97ae524075cc$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $c50b6b986a937e54$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $c50b6b986a937e54$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $c3e9201918a8fd27$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $1bc3c607cc1507c7$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $2180f0e9ff5dad08$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $89173479274f9ad5$export$1cfafeee2987818b)();
    const { referrer: referrer } = $2180f0e9ff5dad08$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $2180f0e9ff5dad08$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $ffcab85cacd4ebee$export$1df9218a526d318d extends (0, $407a44de521243bb$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $ffcab85cacd4ebee$export$4e107b20a7f977(options);
        const sdkSource = (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $efb742987ee4a3aa$export$8ad33f488b1ab046)();
        (0, $8c49af227632e107$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $7550689fe8efd1a0$export$f8ed83d3b6a0b504)(this);
                if (enableMetrics) (0, $751c742c1adfc903$export$91c9ef254b7d0f67)(this);
            }
        });
        if (sendDefaultPii) this.on("beforeSendSession", (0, $0e6458868d27d165$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $354f6ad152059a8c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $354f6ad152059a8c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $ffcab85cacd4ebee$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}








// We keep the handlers globally
const $ecb80d1aa6b5a1db$var$handlers = {};
const $ecb80d1aa6b5a1db$var$instrumented = {};
/** Add a handler function. Returns a function to remove the handler. */ function $ecb80d1aa6b5a1db$export$a4e09611e30da72e(type, handler) {
    $ecb80d1aa6b5a1db$var$handlers[type] = $ecb80d1aa6b5a1db$var$handlers[type] || [];
    $ecb80d1aa6b5a1db$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $ecb80d1aa6b5a1db$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $ecb80d1aa6b5a1db$export$b17eab759a1cb5fe() {
    Object.keys($ecb80d1aa6b5a1db$var$handlers).forEach((key)=>{
        $ecb80d1aa6b5a1db$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $ecb80d1aa6b5a1db$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$ecb80d1aa6b5a1db$var$instrumented[type]) {
        $ecb80d1aa6b5a1db$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $ecb80d1aa6b5a1db$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $ecb80d1aa6b5a1db$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $b0bde6307b9dc37e$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6d0fc2991da9c870$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    const removeHandler = (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, $6d0fc2991da9c870$var$instrumentConsole);
    return removeHandler;
}
function $6d0fc2991da9c870$var$instrumentConsole() {
    if (!("console" in (0, $21592f648406440f$export$f1a6cdb1459e81d1))) return;
    (0, $850185d9d2292f1a$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $21592f648406440f$export$f1a6cdb1459e81d1).console)) return;
        (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $21592f648406440f$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $850185d9d2292f1a$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("console", {
                    args: args,
                    level: level
                });
                const log = (0, $850185d9d2292f1a$export$77c4ce905194557b)[level];
                log?.apply((0, $21592f648406440f$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







const $698a4c665695e7e8$var$WINDOW = (0, $21592f648406440f$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $698a4c665695e7e8$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $698a4c665695e7e8$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $698a4c665695e7e8$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $698a4c665695e7e8$export$67fc34576016d6ec() {
    return "history" in $698a4c665695e7e8$var$WINDOW && !!$698a4c665695e7e8$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $698a4c665695e7e8$export$edf3cb81fd7d2a3e = $698a4c665695e7e8$var$_isFetchSupported;
function $698a4c665695e7e8$var$_isFetchSupported() {
    if (!("fetch" in $698a4c665695e7e8$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $698a4c665695e7e8$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $698a4c665695e7e8$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$698a4c665695e7e8$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($698a4c665695e7e8$export$d5f608b368e73f38($698a4c665695e7e8$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $698a4c665695e7e8$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $698a4c665695e7e8$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $4ffc93ad374b9e74$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $698a4c665695e7e8$export$531055a6c684a70a() {
    return "ReportingObserver" in $698a4c665695e7e8$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $698a4c665695e7e8$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$698a4c665695e7e8$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}





/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5a3aacbfac61d6f0$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, ()=>$5a3aacbfac61d6f0$var$instrumentFetch(undefined, skipNativeFetchCheck));
    return removeHandler;
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 * Returns a function to remove the handler.
 *
 * Only used internally
 * @hidden
 */ function $5a3aacbfac61d6f0$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, ()=>$5a3aacbfac61d6f0$var$instrumentFetch($5a3aacbfac61d6f0$var$streamHandler));
    return removeHandler;
}
function $5a3aacbfac61d6f0$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $698a4c665695e7e8$export$c82d238e23c40b21)()) return;
    (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $21592f648406440f$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $5a3aacbfac61d6f0$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $5a3aacbfac61d6f0$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $21592f648406440f$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $e73c4a1df54c54bb$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === "always") // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $5a3aacbfac61d6f0$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $5a3aacbfac61d6f0$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $5a3aacbfac61d6f0$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $5a3aacbfac61d6f0$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $5a3aacbfac61d6f0$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($5a3aacbfac61d6f0$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $5a3aacbfac61d6f0$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $5a3aacbfac61d6f0$var$getUrlFromResource(resource),
            method: $5a3aacbfac61d6f0$var$hasProp(options, "method") ? String(options.method).toUpperCase() : (0, $e73c4a1df54c54bb$export$6d3d1f317d7cda57)(resource) && $5a3aacbfac61d6f0$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $5a3aacbfac61d6f0$var$getUrlFromResource(arg),
        method: $5a3aacbfac61d6f0$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $5a3aacbfac61d6f0$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $e73c4a1df54c54bb$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $6044b4d8c2ba8dee$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $2f2a5494d867c03c$var$DEFAULT_BASE_URL = "thismessage:/";
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $2f2a5494d867c03c$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $2f2a5494d867c03c$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $2f2a5494d867c03c$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ("canParse" in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2f2a5494d867c03c$export$5339fcdc8e2a427c(url) {
    if ($2f2a5494d867c03c$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $2f2a5494d867c03c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $2f2a5494d867c03c$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $2f2a5494d867c03c$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $d58f778607a31700$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $d58f778607a31700$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $d58f778607a31700$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $d58f778607a31700$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $d58f778607a31700$export$d7a7d984b0791405] = "route";
        }
        if (!$2f2a5494d867c03c$export$e258e13805402ba7(urlObject)) {
            attributes[0, $d58f778607a31700$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $2f2a5494d867c03c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2f2a5494d867c03c$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2f2a5494d867c03c$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2f2a5494d867c03c$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $2f2a5494d867c03c$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7e467fba34a8eff8$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




const $506c6c605f2191b5$export$56d8a8a25bd48b81 = (0, $21592f648406440f$export$f1a6cdb1459e81d1);


const $aad1c6853774420d$var$DEBOUNCE_DURATION = 1000;
let $aad1c6853774420d$var$debounceTimerID;
let $aad1c6853774420d$var$lastCapturedEventType;
let $aad1c6853774420d$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $aad1c6853774420d$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, $aad1c6853774420d$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $aad1c6853774420d$export$3014bbf0af0e1d4a() {
    if (!(0, $506c6c605f2191b5$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $aad1c6853774420d$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $506c6c605f2191b5$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $aad1c6853774420d$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $aad1c6853774420d$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $aad1c6853774420d$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $aad1c6853774420d$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $aad1c6853774420d$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $aad1c6853774420d$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $aad1c6853774420d$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($aad1c6853774420d$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $1bc3c607cc1507c7$export$e73679ffaf56810e)(target, "_sentryId", (0, $c50b6b986a937e54$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$aad1c6853774420d$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $aad1c6853774420d$var$lastCapturedEventType = event.type;
            $aad1c6853774420d$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($aad1c6853774420d$var$debounceTimerID);
        $aad1c6853774420d$var$debounceTimerID = (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).setTimeout(()=>{
            $aad1c6853774420d$var$lastCapturedEventTargetId = undefined;
            $aad1c6853774420d$var$lastCapturedEventType = undefined;
        }, $aad1c6853774420d$var$DEBOUNCE_DURATION);
    };
}
function $aad1c6853774420d$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $5677df7a5ee32962$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5677df7a5ee32962$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, $5677df7a5ee32962$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $5677df7a5ee32962$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $5677df7a5ee32962$var$lastHref;
        $5677df7a5ee32962$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("history", handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $698a4c665695e7e8$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $5677df7a5ee32962$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $5677df7a5ee32962$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $5677df7a5ee32962$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $506c6c605f2191b5$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $506c6c605f2191b5$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $5677df7a5ee32962$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}



const $d68605180a09ffd5$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d68605180a09ffd5$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, $d68605180a09ffd5$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $d68605180a09ffd5$export$c67d533bf77cbf54() {
    if (!(0, $506c6c605f2191b5$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $e73c4a1df54c54bb$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $d68605180a09ffd5$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$d68605180a09ffd5$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$d68605180a09ffd5$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$d68605180a09ffd5$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $e73c4a1df54c54bb$export$844ec244b1367d54)(header) && (0, $e73c4a1df54c54bb$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$d68605180a09ffd5$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $9a227e6c9c778209$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $d68605180a09ffd5$var$parseXhrUrlArg(url) {
    if ((0, $e73c4a1df54c54bb$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0a4177dd94ac9c6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $cee08fbf8271c42f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $cee08fbf8271c42f$var$INTEGRATION_NAME = "Breadcrumbs";
const $cee08fbf8271c42f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $cee08fbf8271c42f$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $6d0fc2991da9c870$export$1d6e0d073f9e6723)($cee08fbf8271c42f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $aad1c6853774420d$export$5aeffd3db2cf9df7)($cee08fbf8271c42f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $d68605180a09ffd5$export$26ace48dd54c9aea)($cee08fbf8271c42f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $5a3aacbfac61d6f0$export$f75d3c772c923df0)($cee08fbf8271c42f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $5677df7a5ee32962$export$3f18c56c58114e75)($cee08fbf8271c42f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $cee08fbf8271c42f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $cee08fbf8271c42f$export$c079d904b326663a = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($cee08fbf8271c42f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $cee08fbf8271c42f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client) return;
        (0, $c15d0003e83e1f09$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $c50b6b986a937e54$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $cee08fbf8271c42f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $cee08fbf8271c42f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $e0a4177dd94ac9c6$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$cee08fbf8271c42f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$cee08fbf8271c42f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $cee08fbf8271c42f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $cee08fbf8271c42f$var$_isEvent(event) ? event.target : event;
            target = (0, $89173479274f9ad5$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $89173479274f9ad5$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $c15d0003e83e1f09$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $cee08fbf8271c42f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $7e467fba34a8eff8$export$d771ef054122c30a)(handlerData.level),
            message: (0, $937c50c58c7016cb$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $937c50c58c7016cb$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $c15d0003e83e1f09$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $cee08fbf8271c42f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $d68605180a09ffd5$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $6044b4d8c2ba8dee$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $c15d0003e83e1f09$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $cee08fbf8271c42f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $c15d0003e83e1f09$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $6044b4d8c2ba8dee$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $c15d0003e83e1f09$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $cee08fbf8271c42f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2f2a5494d867c03c$export$7a5253c0f62e0150)((0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2f2a5494d867c03c$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2f2a5494d867c03c$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $c15d0003e83e1f09$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $cee08fbf8271c42f$var$_isEvent(event) {
    return !!event && !!event.target;
}




// Using a comma-separated string and split for smaller bundle size vs an array literal
const $57b175cb2d3b36d0$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $57b175cb2d3b36d0$var$INTEGRATION_NAME = "BrowserApiErrors";
const $57b175cb2d3b36d0$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $57b175cb2d3b36d0$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81), "setTimeout", $57b175cb2d3b36d0$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81), "setInterval", $57b175cb2d3b36d0$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)((0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81), "requestAnimationFrame", $57b175cb2d3b36d0$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81)) (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $57b175cb2d3b36d0$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $57b175cb2d3b36d0$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$57b175cb2d3b36d0$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $57b175cb2d3b36d0$export$59bfe9f1c76150e = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($57b175cb2d3b36d0$var$_browserApiErrorsIntegration);
function $57b175cb2d3b36d0$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $2180f0e9ff5dad08$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $b0bde6307b9dc37e$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $57b175cb2d3b36d0$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $2180f0e9ff5dad08$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $b0bde6307b9dc37e$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $57b175cb2d3b36d0$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $b0bde6307b9dc37e$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $1bc3c607cc1507c7$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $b0bde6307b9dc37e$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $2180f0e9ff5dad08$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $57b175cb2d3b36d0$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($57b175cb2d3b36d0$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $2180f0e9ff5dad08$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $b0bde6307b9dc37e$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $57b175cb2d3b36d0$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $2180f0e9ff5dad08$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $b0bde6307b9dc37e$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $1bc3c607cc1507c7$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $57b175cb2d3b36d0$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $57b175cb2d3b36d0$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $008709bec5e2718f$export$1baa7880e357371c = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $e0a4177dd94ac9c6$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $c3e9201918a8fd27$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $c3e9201918a8fd27$export$667e7b4d445d566b)();
            // User data can be set at any time, for example async after Sentry.init has run and the initial session
            // envelope was already sent, but still on the initial page.
            // Therefore, we have to update the ongoing session with the new user data if it exists, to send the `did`.
            // In theory, sessions, as well as user data is always put onto the isolation scope. So we listen to the
            // isolation scope for changes and update the session with the new user data if it exists.
            // This will not catch users set onto other scopes, like the current scope. For now, we'll accept this limitation.
            // The alternative is to update and capture the session from within the scope. This could be too costly or would not
            // play well with session aggregates on the server side. Since this happens in the scope class, we'd need change
            // scope behaviour in the browser.
            const isolationScope = (0, $23ec97ae524075cc$export$68f3af03034c9e90)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                // sessions only care about user id and ip address, so we only need to capture the session if the user has changed
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    // the scope class already writes the user to its session, so we only need to capture the session here
                    (0, $c3e9201918a8fd27$export$667e7b4d445d566b)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === "route") // We want to create a session for every navigation as well
            (0, $5677df7a5ee32962$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== to) {
                    (0, $c3e9201918a8fd27$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $c3e9201918a8fd27$export$667e7b4d445d566b)();
                }
            });
        }
    };
});







/**
 * Captures a span and returns a JSON representation to be enqueued for sending.
 *
 * IMPORTANT: This function converts the span to JSON immediately to avoid writing
 * to an already-ended OTel span instance (which is blocked by the OTel Span class).
 *
 * @returns the final serialized span with a reference to its segment span. This reference
 * is needed later on to compute the DSC for the span envelope.
 */ function $9229fb8e38e5e2fe$export$b1e72a433efdc918(span, client) {
    // Convert to JSON FIRST - we cannot write to an already-ended span
    const spanJSON = (0, $f5169fe230b9fd92$export$db0cad9e44f67af8)(span);
    const segmentSpan = (0, $f5169fe230b9fd92$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $f5169fe230b9fd92$export$db0cad9e44f67af8)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $bad21278ffba8b28$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $d8f548fa6f8327a6$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $9229fb8e38e5e2fe$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    // Backfill span data from OTel semantic conventions when not explicitly set.
    // OTel-originated spans don't have sentry.op, description, etc. — the non-streamed path
    // infers these in the SentrySpanExporter, but streamed spans skip the exporter entirely.
    // Access `kind` via duck-typing — OTel span objects have this property but it's not on Sentry's Span type.
    // This must run before all hooks and beforeSendSpan so that user callbacks can see and override inferred values.
    const spanKind = span.kind;
    $9229fb8e38e5e2fe$export$c3bd71cc0f7b2c55(spanJSON, spanKind);
    if (spanJSON.is_segment) // Allow hook subscribers to mutate the segment span JSON
    // This also invokes the `processSegmentSpan` hook of all integrations
    client.emit("processSegmentSpan", spanJSON);
    // This allows hook subscribers to mutate the span JSON
    // This also invokes the `processSpan` hook of all integrations
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan } = client.getOptions();
    const processedSpan = beforeSendSpan && (0, $f7c9c832970bb79f$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? $9229fb8e38e5e2fe$export$d38dd0f511e8d9ba(spanJSON, beforeSendSpan) : spanJSON;
    // Backfill sentry.span.source from sentry.source. Only `sentry.span.source` is respected by Sentry.
    // TODO(v11): Remove this backfill once we renamed SEMANTIC_ATTRIBUTE_SENTRY_SOURCE to sentry.span.source
    const spanNameSource = processedSpan.attributes?.[0, $d58f778607a31700$export$d7a7d984b0791405];
    if (spanNameSource) $9229fb8e38e5e2fe$export$146fcadff0eefcf3(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        "sentry.span.source": spanNameSource
    });
    return {
        ...(0, $f5169fe230b9fd92$export$5402aa553bcf35f3)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $9229fb8e38e5e2fe$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // avoid overwriting any previously set attributes (from users or potentially our SDK instrumentation)
    $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
        [(0, $d58f778607a31700$export$f5cefb258679b29e)]: release,
        [(0, $d58f778607a31700$export$d1b1dbb47f5ba57c)]: environment,
        [(0, $d58f778607a31700$export$4626f2be16112c1c)]: serializedSegmentSpan.name,
        [(0, $d58f778607a31700$export$25fa4a1832d3736a)]: serializedSegmentSpan.span_id,
        [(0, $d58f778607a31700$export$87a4807042e1f1bb)]: sdk?.sdk?.name,
        [(0, $d58f778607a31700$export$301ebe936458e291)]: sdk?.sdk?.version,
        ...sendDefaultPii ? {
            [(0, $d58f778607a31700$export$1f9cc1d34ea098a0)]: scopeData.user?.id,
            [(0, $d58f778607a31700$export$b7466609ef46c07e)]: scopeData.user?.email,
            [(0, $d58f778607a31700$export$8d592bdaea63b930)]: scopeData.user?.ip_address,
            [(0, $d58f778607a31700$export$c05ee933d3f74b2b)]: scopeData.user?.username
        } : {},
        ...scopeData.attributes
    });
}
/**
 * Apply a user-provided beforeSendSpan callback to a span JSON.
 */ function $9229fb8e38e5e2fe$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        (0, $f5169fe230b9fd92$export$d11691ff45a3e535)();
        return span;
    }
    return modifedSpan;
}
/**
 * Safely set attributes on a span JSON.
 * If an attribute already exists, it will not be overwritten.
 */ function $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
// OTel SpanKind values (numeric to avoid importing from @opentelemetry/api)
const $9229fb8e38e5e2fe$var$SPAN_KIND_SERVER = 1;
const $9229fb8e38e5e2fe$var$SPAN_KIND_CLIENT = 2;
/**
 * Infer and backfill span data from OTel semantic conventions.
 * This mirrors what the `SentrySpanExporter` does for non-streamed spans via `getSpanData`/`inferSpanData`.
 * Streamed spans skip the exporter, so we do the inference here during capture.
 *
 * Backfills: `sentry.op`, `sentry.source`, and `name` (description).
 * Uses `safeSetSpanJSONAttributes` so explicitly set attributes are never overwritten.
 */ /** Exported only for tests. */ function $9229fb8e38e5e2fe$export$c3bd71cc0f7b2c55(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes["http.request.method"] || attributes["http.method"];
    if (httpMethod) {
        $9229fb8e38e5e2fe$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes["db.system.name"] || attributes["db.system"];
    const opIsCache = typeof attributes[0, $d58f778607a31700$export$1a413bd9a88fdb09] === "string" && `${attributes[0, $d58f778607a31700$export$1a413bd9a88fdb09]}`.startsWith("cache.");
    if (dbSystem && !opIsCache) {
        $9229fb8e38e5e2fe$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes["rpc.service"]) {
        $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
            [(0, $d58f778607a31700$export$1a413bd9a88fdb09)]: "rpc"
        });
        return;
    }
    if (attributes["messaging.system"]) {
        $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
            [(0, $d58f778607a31700$export$1a413bd9a88fdb09)]: "message"
        });
        return;
    }
    const faasTrigger = attributes["faas.trigger"];
    if (faasTrigger) $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
        [(0, $d58f778607a31700$export$1a413bd9a88fdb09)]: `${faasTrigger}`
    });
}
function $9229fb8e38e5e2fe$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    // Infer op: http.client, http.server, or just http
    const opParts = [
        "http"
    ];
    if (spanKind === $9229fb8e38e5e2fe$var$SPAN_KIND_CLIENT) opParts.push("client");
    else if (spanKind === $9229fb8e38e5e2fe$var$SPAN_KIND_SERVER) opParts.push("server");
    if (attributes["sentry.http.prefetch"]) opParts.push("prefetch");
    $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
        [(0, $d58f778607a31700$export$1a413bd9a88fdb09)]: opParts.join(".")
    });
    // If the user set a custom span name via updateSpanName(), apply it — OTel instrumentation
    // may have overwritten span.name after the user set it, so we restore from the attribute.
    const customName = attributes[0, $d58f778607a31700$export$165ce9a229f6f050];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[0, $d58f778607a31700$export$d7a7d984b0791405] === "custom") return;
    // Only overwrite the span name when we have an explicit http.route — it's more specific than
    // what OTel instrumentation sets as the span name. For all other cases (url.full, http.target),
    // the OTel-set name is already good enough and we'd risk producing a worse name (e.g. full URL).
    const httpRoute = attributes["http.route"];
    if (typeof httpRoute === "string") {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
            [(0, $d58f778607a31700$export$d7a7d984b0791405)]: "route"
        });
    } else // Fallback: set source to 'url' for HTTP spans without a route.
    // The spec requires sentry.span.source on segment spans, and the non-streamed exporter
    // always sets this — so we need to ensure it's present for streamed spans too.
    $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
        [(0, $d58f778607a31700$export$d7a7d984b0791405)]: "url"
    });
}
function $9229fb8e38e5e2fe$var$inferDbSpanData(spanJSON, attributes) {
    $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
        [(0, $d58f778607a31700$export$1a413bd9a88fdb09)]: "db"
    });
    // If the user set a custom span name via updateSpanName(), apply it.
    const customName = attributes[0, $d58f778607a31700$export$165ce9a229f6f050];
    if (typeof customName === "string") {
        spanJSON.name = customName;
        return;
    }
    if (attributes[0, $d58f778607a31700$export$d7a7d984b0791405] === "custom") return;
    const statement = attributes["db.statement"];
    if (statement) {
        spanJSON.name = `${statement}`;
        $9229fb8e38e5e2fe$export$146fcadff0eefcf3(spanJSON, {
            [(0, $d58f778607a31700$export$d7a7d984b0791405)]: "task"
        });
    }
}



const $dc5d0ee8548b2347$var$INTEGRATION_NAME = "CultureContext";
const $dc5d0ee8548b2347$var$_cultureContextIntegration = ()=>{
    return {
        name: $dc5d0ee8548b2347$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $dc5d0ee8548b2347$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $dc5d0ee8548b2347$var$getCultureContext();
            if (culture) (0, $9229fb8e38e5e2fe$export$146fcadff0eefcf3)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
/**
 * Captures culture context from the browser.
 *
 * Enabled by default.
 *
 * @example
 * ```js
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.cultureContextIntegration()],
 * });
 * ```
 */ const $dc5d0ee8548b2347$export$ec5976aacdc85985 = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($dc5d0ee8548b2347$var$_cultureContextIntegration);
/**
 * Returns the culture context from the browser's Intl API.
 */ function $dc5d0ee8548b2347$var$getCultureContext() {
    try {
        const intl = (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).Intl;
        if (!intl) return undefined;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        // Ignore errors
        return undefined;
    }
}




let $1aef31181d1457cb$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1aef31181d1457cb$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, $1aef31181d1457cb$var$instrumentError);
}
function $1aef31181d1457cb$var$instrumentError() {
    $1aef31181d1457cb$var$_oldOnErrorHandler = (0, $21592f648406440f$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $21592f648406440f$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("error", handlerData);
        if ($1aef31181d1457cb$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $1aef31181d1457cb$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $21592f648406440f$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $b2fa469b2733a1d0$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b2fa469b2733a1d0$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $ecb80d1aa6b5a1db$export$a4e09611e30da72e)(type, handler);
    (0, $ecb80d1aa6b5a1db$export$e18d6c5462c01368)(type, $b2fa469b2733a1d0$var$instrumentUnhandledRejection);
}
function $b2fa469b2733a1d0$var$instrumentUnhandledRejection() {
    $b2fa469b2733a1d0$var$_oldOnUnhandledRejectionHandler = (0, $21592f648406440f$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $21592f648406440f$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $ecb80d1aa6b5a1db$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($b2fa469b2733a1d0$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $b2fa469b2733a1d0$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $21592f648406440f$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $2997759d04541f80$var$INTEGRATION_NAME = "GlobalHandlers";
const $2997759d04541f80$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $2997759d04541f80$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $2997759d04541f80$var$_installGlobalOnErrorHandler(client);
                $2997759d04541f80$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $2997759d04541f80$var$_installGlobalOnUnhandledRejectionHandler(client);
                $2997759d04541f80$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $2997759d04541f80$export$66acc70e8cf2b71a = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($2997759d04541f80$var$_globalHandlersIntegration);
function $2997759d04541f80$var$_installGlobalOnErrorHandler(client) {
    (0, $1aef31181d1457cb$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $2997759d04541f80$var$getOptions();
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client || (0, $2180f0e9ff5dad08$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $2997759d04541f80$var$_enhanceEventWithInitialFrame((0, $354f6ad152059a8c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $c3e9201918a8fd27$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $2997759d04541f80$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $b2fa469b2733a1d0$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $2997759d04541f80$var$getOptions();
        if ((0, $23ec97ae524075cc$export$6bb76d6eba7e258c)() !== client || (0, $2180f0e9ff5dad08$export$b79738ab10c590b2)()) return;
        const error = $2997759d04541f80$export$b2cc40fa8241780(e);
        const event = (0, $e73c4a1df54c54bb$export$c3825b437cbdea5c)(error) ? $2997759d04541f80$export$1353b5b36844a9ed(error) : (0, $354f6ad152059a8c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $c3e9201918a8fd27$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
/**
 *
 */ function $2997759d04541f80$export$b2cc40fa8241780(error) {
    if ((0, $e73c4a1df54c54bb$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $2997759d04541f80$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $2997759d04541f80$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $2997759d04541f80$var$getFilenameFromUrl(url) ?? (0, $89173479274f9ad5$export$1cfafeee2987818b)(),
        function: (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac),
        in_app: true
    });
    return event;
}
function $2997759d04541f80$var$globalHandlerLog(type) {
    (0, $e0a4177dd94ac9c6$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $2997759d04541f80$var$getOptions() {
    const client = (0, $23ec97ae524075cc$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $2997759d04541f80$var$getFilenameFromUrl(url) {
    if (!(0, $e73c4a1df54c54bb$export$844ec244b1367d54)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith("data:")) return `<${(0, $2f2a5494d867c03c$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $fbafd22d4c3c37a2$export$1378794447170364 = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).navigator && !(0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).location && !(0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $2180f0e9ff5dad08$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            // if none of the information we want exists, don't bother
            if (!(0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).navigator && !(0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).location && !(0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $2180f0e9ff5dad08$export$a3c4a8453e8936f0)();
            (0, $9229fb8e38e5e2fe$export$146fcadff0eefcf3)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                "url.full": reqData.url || undefined,
                "http.request.header.user_agent": reqData.headers["User-Agent"],
                "http.request.header.referer": reqData.headers["Referer"]
            });
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $c88ebdf4f6e3e3a8$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $e73c4a1df54c54bb$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $c88ebdf4f6e3e3a8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $c88ebdf4f6e3e3a8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $e73c4a1df54c54bb$export$49034edbe6b62415)(error[key], Error)) {
        $c88ebdf4f6e3e3a8$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $c88ebdf4f6e3e3a8$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $c88ebdf4f6e3e3a8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($c88ebdf4f6e3e3a8$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $e73c4a1df54c54bb$export$49034edbe6b62415)(childError, Error)) {
            $c88ebdf4f6e3e3a8$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $c88ebdf4f6e3e3a8$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $c88ebdf4f6e3e3a8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $c88ebdf4f6e3e3a8$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $c88ebdf4f6e3e3a8$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$c88ebdf4f6e3e3a8$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $c88ebdf4f6e3e3a8$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $2dc4d36fb575b77e$var$DEFAULT_KEY = "cause";
const $2dc4d36fb575b77e$var$DEFAULT_LIMIT = 5;
const $2dc4d36fb575b77e$var$INTEGRATION_NAME = "LinkedErrors";
const $2dc4d36fb575b77e$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $2dc4d36fb575b77e$var$DEFAULT_LIMIT;
    const key = options.key || $2dc4d36fb575b77e$var$DEFAULT_KEY;
    return {
        name: $2dc4d36fb575b77e$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $c88ebdf4f6e3e3a8$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $354f6ad152059a8c$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $2dc4d36fb575b77e$export$ebabb00eb7f3a395 = (0, $d9cad6cf2ba3b190$export$2323046b9414659f)($2dc4d36fb575b77e$var$_linkedErrorsIntegration);




const $05d18a929a793ee3$var$OPERA10_PRIORITY = 10;
const $05d18a929a793ee3$var$OPERA11_PRIORITY = 20;
const $05d18a929a793ee3$var$CHROME_PRIORITY = 30;
const $05d18a929a793ee3$var$WINJS_PRIORITY = 40;
const $05d18a929a793ee3$var$GECKO_PRIORITY = 50;
function $05d18a929a793ee3$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $05d18a929a793ee3$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $05d18a929a793ee3$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $05d18a929a793ee3$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $05d18a929a793ee3$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $05d18a929a793ee3$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($05d18a929a793ee3$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $05d18a929a793ee3$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $05d18a929a793ee3$var$createFrame(filename, (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $05d18a929a793ee3$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $05d18a929a793ee3$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $05d18a929a793ee3$var$extractSafariExtensionDetails(parts[1] || (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac), parts[2]);
        return $05d18a929a793ee3$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $05d18a929a793ee3$export$263a749fff749872 = [
    $05d18a929a793ee3$var$CHROME_PRIORITY,
    $05d18a929a793ee3$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $05d18a929a793ee3$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $05d18a929a793ee3$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $05d18a929a793ee3$var$gecko = (line)=>{
    const parts = $05d18a929a793ee3$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $05d18a929a793ee3$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac);
        [func, filename] = $05d18a929a793ee3$var$extractSafariExtensionDetails(func, filename);
        return $05d18a929a793ee3$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $05d18a929a793ee3$export$cdba47a5dd2804d = [
    $05d18a929a793ee3$var$GECKO_PRIORITY,
    $05d18a929a793ee3$var$gecko
];
const $05d18a929a793ee3$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $05d18a929a793ee3$var$winjs = (line)=>{
    const parts = $05d18a929a793ee3$var$winjsRegex.exec(line);
    return parts ? $05d18a929a793ee3$var$createFrame(parts[2], parts[1] || (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $05d18a929a793ee3$export$179460296da408e8 = [
    $05d18a929a793ee3$var$WINJS_PRIORITY,
    $05d18a929a793ee3$var$winjs
];
const $05d18a929a793ee3$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $05d18a929a793ee3$var$opera10 = (line)=>{
    const parts = $05d18a929a793ee3$var$opera10Regex.exec(line);
    return parts ? $05d18a929a793ee3$var$createFrame(parts[2], parts[3] || (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $05d18a929a793ee3$export$f892b52c880ffc7a = [
    $05d18a929a793ee3$var$OPERA10_PRIORITY,
    $05d18a929a793ee3$var$opera10
];
const $05d18a929a793ee3$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $05d18a929a793ee3$var$opera11 = (line)=>{
    const parts = $05d18a929a793ee3$var$opera11Regex.exec(line);
    return parts ? $05d18a929a793ee3$var$createFrame(parts[5], parts[3] || parts[4] || (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $05d18a929a793ee3$export$af11af13f09fb0dc = [
    $05d18a929a793ee3$var$OPERA11_PRIORITY,
    $05d18a929a793ee3$var$opera11
];
const $05d18a929a793ee3$export$7197c0fe6554c079 = [
    $05d18a929a793ee3$export$263a749fff749872,
    $05d18a929a793ee3$export$cdba47a5dd2804d
];
const $05d18a929a793ee3$export$2b2b997d81bf3907 = (0, $b0bde6307b9dc37e$export$a5739666fb2d03d4)(...$05d18a929a793ee3$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $05d18a929a793ee3$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $b0bde6307b9dc37e$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1d95a19f73f6ebd6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $f86c4dffe50e5ccd$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $f86c4dffe50e5ccd$export$e464f4a514ac28a8(name) {
    const cached = $f86c4dffe50e5ccd$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $506c6c605f2191b5$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $698a4c665695e7e8$export$d5f608b368e73f38)(impl)) return $f86c4dffe50e5ccd$var$cachedImplementations[name] = impl.bind((0, $506c6c605f2191b5$export$56d8a8a25bd48b81));
    const document = (0, $506c6c605f2191b5$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $1d95a19f73f6ebd6$export$16a28057038b10ef) && (0, $850185d9d2292f1a$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $f86c4dffe50e5ccd$var$cachedImplementations[name] = impl.bind((0, $506c6c605f2191b5$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $f86c4dffe50e5ccd$export$8aa36702e8c8978(name) {
    $f86c4dffe50e5ccd$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $f86c4dffe50e5ccd$export$e7aa7bc5c1b3cfb3(...rest) {
    return $f86c4dffe50e5ccd$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $f86c4dffe50e5ccd$export$831dc9f2ab0a617b(...rest) {
    return $f86c4dffe50e5ccd$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $a3f6e8f166a6f73a$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $a3f6e8f166a6f73a$export$b2311068c46d7cc8(options, nativeFetch = (0, $f86c4dffe50e5ccd$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $f86c4dffe50e5ccd$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $a94c66d3fd60f683$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $b01da0ce7a78cb97$export$85a4f67f852183e6)(options.bufferSize || $a3f6e8f166a6f73a$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $6e0ca28bfda71ad1$export$dc236a86065879fc() {
    if ($6e0ca28bfda71ad1$var$_isEmbeddedBrowserExtension()) {
        if (0, $e0a4177dd94ac9c6$export$16a28057038b10ef) (0, $850185d9d2292f1a$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $6e0ca28bfda71ad1$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).window === "undefined") // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $89173479274f9ad5$export$1cfafeee2987818b)();
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81) === (0, $2180f0e9ff5dad08$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $0e0f59be2db8fb5f$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $235934cdeac6e652$export$cb3c5c2ceb9818ba)(),
        (0, $7ecb5c803da9ca0f$export$7918117e9202e4fb)(),
        (0, $5646b2aebec8f115$export$97457a453081a5b3)(),
        (0, $57b175cb2d3b36d0$export$59bfe9f1c76150e)(),
        (0, $cee08fbf8271c42f$export$c079d904b326663a)(),
        (0, $2997759d04541f80$export$66acc70e8cf2b71a)(),
        (0, $2dc4d36fb575b77e$export$ebabb00eb7f3a395)(),
        (0, $00d0862ab0be797e$export$6d39aa44cd0c7567)(),
        (0, $fbafd22d4c3c37a2$export$1378794447170364)(),
        (0, $dc5d0ee8548b2347$export$ec5976aacdc85985)(),
        (0, $008709bec5e2718f$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $0e0f59be2db8fb5f$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $6e0ca28bfda71ad1$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $0e0f59be2db8fb5f$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $b0bde6307b9dc37e$export$1d5cf88b347146d4)(options.stackParser || (0, $05d18a929a793ee3$export$2b2b997d81bf3907)),
        integrations: (0, $d9cad6cf2ba3b190$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $a3f6e8f166a6f73a$export$b2311068c46d7cc8)
    };
    return (0, $7f8e7288e0907ec2$export$5333c3f1c58d9bc1)((0, $ffcab85cacd4ebee$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0e0f59be2db8fb5f$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0e0f59be2db8fb5f$export$4e4d8b287d028b6b(callback) {
    callback();
}


const $90676fd7b60b5338$var$IGNORE_ERRORS = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error promise rejection captured",
    /chrome-extension:/i,
    /moz-extension:/i
];
const $90676fd7b60b5338$var$EXTERNAL_HOST_SUBSTRINGS = [
    "google.com",
    "gstatic.com",
    "googleapis.com",
    "clarity.ms",
    "recaptcha.net",
    "rdstation.com"
];
const $90676fd7b60b5338$var$SCRUB_KEYS = new Set([
    "password",
    "senha",
    "token",
    "authorization",
    "csrfmiddlewaretoken",
    "cpf",
    "cnpj"
]);
function $90676fd7b60b5338$var$tracesSampleRateForEnvironment(environment) {
    return environment === "dev" ? 1.0 : 0.01;
}
function $90676fd7b60b5338$var$scrubUrlSearchParams(url) {
    try {
        const u = new URL(url, window.location.origin);
        let changed = false;
        for (const key of [
            ...u.searchParams.keys()
        ])if ($90676fd7b60b5338$var$SCRUB_KEYS.has(key.toLowerCase())) {
            u.searchParams.set(key, "[Filtered]");
            changed = true;
        }
        return changed ? u.toString() : url;
    } catch  {
        return url;
    }
}
function $90676fd7b60b5338$var$scrubValue(value, depth = 0) {
    if (depth > 10 || value === null || value === undefined) return value;
    if (typeof value === "string") return $90676fd7b60b5338$var$scrubUrlSearchParams(value);
    if (Array.isArray(value)) return value.map((item)=>$90676fd7b60b5338$var$scrubValue(item, depth + 1));
    if (typeof value === "object") {
        const out = {};
        for (const [key, val] of Object.entries(value)){
            const lk = key.toLowerCase();
            if ($90676fd7b60b5338$var$SCRUB_KEYS.has(lk)) out[key] = "[Filtered]";
            else out[key] = $90676fd7b60b5338$var$scrubValue(val, depth + 1);
        }
        return out;
    }
    return value;
}
function $90676fd7b60b5338$var$scrubEvent(event) {
    if (event.request?.url) event.request.url = $90676fd7b60b5338$var$scrubUrlSearchParams(event.request.url);
    if (event.request?.data) event.request.data = $90676fd7b60b5338$var$scrubValue(event.request.data);
    if (event.extra) event.extra = $90676fd7b60b5338$var$scrubValue(event.extra);
    if (event.contexts) event.contexts = $90676fd7b60b5338$var$scrubValue(event.contexts);
}
function $90676fd7b60b5338$var$looksLikeExternalNetworkNoise(event, hint) {
    const message = hint?.originalException?.message || event.exception?.values?.[0]?.value || "";
    const msg = String(message).toLowerCase();
    if (!msg.includes("network") && !msg.includes("failed to fetch")) return false;
    const reqUrl = event.request?.url || hint?.originalException?.config?.url || hint?.originalException?.request?.responseURL || "";
    const urlStr = String(reqUrl).toLowerCase();
    if (!urlStr) return false;
    try {
        const host = new URL(urlStr, window.location.origin).hostname;
        return $90676fd7b60b5338$var$EXTERNAL_HOST_SUBSTRINGS.some((fragment)=>host.includes(fragment));
    } catch  {
        return $90676fd7b60b5338$var$EXTERNAL_HOST_SUBSTRINGS.some((fragment)=>urlStr.includes(fragment));
    }
}
function $90676fd7b60b5338$var$beforeSend(event, hint) {
    try {
        if ($90676fd7b60b5338$var$looksLikeExternalNetworkNoise(event, hint)) return null;
        $90676fd7b60b5338$var$scrubEvent(event);
        return event;
    } catch  {
        return event;
    }
}
function $90676fd7b60b5338$var$applyDomTags() {
    if (typeof document === "undefined" || !document.body) return;
    const body = document.body;
    const page = body.getAttribute("js-page");
    if (page) $c3e9201918a8fd27$export$a37d07ee78eb4569("page", page);
    const leilaoId = body.dataset.leilaoId;
    if (leilaoId) $c3e9201918a8fd27$export$a37d07ee78eb4569("leilao_id", leilaoId);
    const loteId = body.dataset.loteId;
    if (loteId) $c3e9201918a8fd27$export$a37d07ee78eb4569("lote_id", loteId);
}
function $90676fd7b60b5338$var$applyUserContext(cfg) {
    if (!cfg.user) return;
    $c3e9201918a8fd27$export$8b6bb3dd62a01be2({
        id: String(cfg.user.id),
        username: cfg.user.username
    });
    if (cfg.user.tipo_pessoa) $c3e9201918a8fd27$export$a37d07ee78eb4569("tipo_pessoa", cfg.user.tipo_pessoa);
}
function $90676fd7b60b5338$export$1aee95c530b1861b() {
    if (typeof window === "undefined") return;
    const cfg = window.GLITCHTIP_CONFIG || {};
    if (!cfg.dsn) return;
    if ($23ec97ae524075cc$export$6bb76d6eba7e258c()) return;
    $0e0f59be2db8fb5f$export$2cd8252107eb640b({
        dsn: cfg.dsn,
        environment: cfg.environment,
        release: cfg.release || undefined,
        tracesSampleRate: $90676fd7b60b5338$var$tracesSampleRateForEnvironment(cfg.environment),
        beforeSend: $90676fd7b60b5338$var$beforeSend,
        ignoreErrors: $90676fd7b60b5338$var$IGNORE_ERRORS,
        autoSessionTracking: false
    });
    $90676fd7b60b5338$var$applyUserContext(cfg);
    $90676fd7b60b5338$var$applyDomTags();
}
function $90676fd7b60b5338$export$9257625807ef4b3a() {
    if (typeof window === "undefined") return;
    try {
        const params = new URLSearchParams(window.location.search);
        if (params.get("glitchtip-debug") !== "1") return;
        setTimeout(()=>{
            throw new Error("GlitchTip frontend smoke test (?glitchtip-debug=1)");
        }, 0);
    } catch  {
    /* ignore */ }
}
function $90676fd7b60b5338$export$7d8bd70438e04f3a() {
    if (typeof window === "undefined") return;
    const api = window.api;
    if (!api || api.__glitchTipInterceptors) return;
    api.__glitchTipInterceptors = true;
    api.interceptors.request.use((config)=>{
        if (!$23ec97ae524075cc$export$6bb76d6eba7e258c()) return config;
        $c15d0003e83e1f09$export$efda9a273d7a036d({
            category: "axios.request",
            type: "http",
            data: {
                method: config.method,
                url: config.url
            }
        });
        return config;
    }, (error)=>Promise.reject(error));
    api.interceptors.response.use((response)=>{
        if (!$23ec97ae524075cc$export$6bb76d6eba7e258c()) return response;
        $c15d0003e83e1f09$export$efda9a273d7a036d({
            category: "axios.response",
            type: "http",
            data: {
                status: response.status,
                url: response.config?.url,
                method: response.config?.method
            }
        });
        return response;
    }, (error)=>{
        if (!$23ec97ae524075cc$export$6bb76d6eba7e258c()) return Promise.reject(error);
        const status = error.response?.status;
        const cfgErr = error.config || {};
        $c15d0003e83e1f09$export$efda9a273d7a036d({
            category: "axios.error",
            type: "http",
            level: "error",
            data: {
                status: status,
                url: cfgErr.url,
                method: cfgErr.method
            }
        });
        if (typeof status === "number" && status >= 500 && status < 600) $c3e9201918a8fd27$export$f5282963edea4a68(error, {
            tags: {
                axios_http_status: String(status)
            },
            fingerprint: [
                "axios",
                String(cfgErr.url || ""),
                String(status)
            ]
        });
        return Promise.reject(error);
    });
}


/**
 * Toast "Você está sem conexão" — global, registrado via main.js.
 *
 * Decisão consciente:
 * - Usamos APENAS os eventos `offline`/`online` do browser.
 * - `navigator.onLine === false` é confiável quando true: se o browser diz
 *   "offline", está realmente offline. O contrário (true) pode mentir, mas
 *   isso só é problema em sinalizar AUSÊNCIA — e neste toast só nos importa
 *   sinalizar PRESENÇA de offline, então o risco é só não mostrar em casos
 *   raros (captive portal etc.), nunca mostrar um falso positivo.
 * - NÃO usamos polling HTTP: gera ruído, falsos positivos em dev/localhost,
 *   e disputa com o servidor. Para detecção fina dentro da página de lote,
 *   usamos o estado do WebSocket no `websocket.store.js`.
 */ function $0377339b390f9aed$export$3a4ac90595086862() {
    if (typeof window === "undefined") return;
    let toastRef = null;
    function showToast() {
        if (toastRef) return;
        const G = window.GLOBAL;
        if (!G?.toastifyOffline) return;
        toastRef = G.toastifyOffline();
    }
    function hideToast() {
        toastRef?.hideToast?.();
        toastRef = null;
    }
    function sync() {
        if (navigator.onLine === false) showToast();
        else hideToast();
    }
    window.addEventListener("offline", sync);
    window.addEventListener("online", sync);
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync, {
        once: true
    });
    else sync();
}


function $6074568c9c4450be$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == "text" ? "password" : "text";
            if (input.type == "text") item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector(".password");
        buttonPass.addEventListener("click", handleEvent(div));
    });
}


function $2914c72b259257f0$export$2e2bcd8739ae039() {
    const allFormsErrors = document.querySelectorAll("[id^='form-errors']");
    allFormsErrors.forEach((formErrors)=>showErrors(formErrors));
    function showErrors(formErrors) {
        const errorsText = formErrors.textContent;
        const errors = JSON.parse(errorsText).__all__;
        errors && errors.forEach((error)=>error ? GLOBAL.showToastify(error) : "");
    }
}


function $7b5c18274c293bb7$export$2e2bcd8739ae039() {
    const el = document.querySelector(".swiper-home");
    if (!el) return;
    if (!el.querySelectorAll(".swiper-slide").length) return;
    const swiperHome = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 40,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-home .custom-arrow-next",
            prevEl: ".swiper-home .custom-arrow-prev"
        }
    });
}


function $ddc583c3c80e0943$export$2e2bcd8739ae039() {
    const listaItens = document.querySelectorAll(".col-1-list li");
    const conteudos = document.querySelectorAll(".col-2-wrapper .conteudo");
    listaItens.forEach((item)=>{
        item.addEventListener("click", ()=>{
            listaItens.forEach((item)=>{
                item.classList.remove("ativo");
            });
            item.classList.add("ativo");
            const target = item.getAttribute("data-target");
            conteudos.forEach((conteudo)=>{
                conteudo.classList.remove("ativo");
            });
            const conteudoSelecionado = document.getElementById(target);
            if (conteudoSelecionado) conteudoSelecionado.classList.add("ativo");
        });
    });
    function getURLParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }
    const tabId = getURLParameter("tab_id");
    if (tabId) {
        listaItens.forEach((item)=>{
            item.classList.remove("ativo");
        });
        conteudos.forEach((conteudo)=>{
            conteudo.classList.remove("ativo");
        });
        const id = Number(tabId) - 1;
        const conteudoSelecionado = document.querySelectorAll(".col-1-list li")[id];
        if (conteudoSelecionado) {
            conteudoSelecionado.classList.add("ativo");
            console.log(conteudoSelecionado);
            const target = conteudoSelecionado.getAttribute("data-target");
            const content = document.getElementById(target);
            content.classList.add("ativo");
        }
    }
}


function $10c50974faba5f51$export$2e2bcd8739ae039() {
    function closeAllDropdowns() {
        const dropdowns = document.querySelectorAll(".custom-dropdown-content");
        dropdowns?.forEach((dropdown)=>{
            dropdown.style.display = "none";
        });
    }
    function toggleDropdown(dropdownId) {
        let dropdown = document.getElementById(dropdownId);
        let display = dropdown.style.display;
        if (display === "block") dropdown && (dropdown.style.display = "none");
        else {
            closeAllDropdowns();
            dropdown && (dropdown.style.display = "block");
        }
    }
    function addToggleEvent(buttonId, dropdownId) {
        let button = document.getElementById(buttonId);
        button?.addEventListener("click", function() {
            toggleDropdown(dropdownId);
        });
    }
    addToggleEvent("categorias-button", "categorias-dropdown");
    addToggleEvent("estado-button", "estado-dropdown");
    addToggleEvent("cidade-button", "cidade-dropdown");
    addToggleEvent("bairro-button", "bairro-dropdown");
    addToggleEvent("preco-button", "preco-dropdown");
}


function $d39faeca8f198153$export$2e2bcd8739ae039() {
    const swiperLotes = new Swiper(".cards-wrapper", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        breakpoints: {
            540: {
                slidesPerView: 2.2,
                slidesPerGroup: 2,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 2.5,
                slidesPerGroup: 2,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 30
            }
        },
        navigation: {
            // nextEl: ".swiper-button-next",
            // prevEl: ".swiper-button-prev",
            nextEl: ".custom-arrow-next",
            prevEl: ".custom-arrow-prev"
        }
    });
}


function $0fa4be6d176625ab$export$2e2bcd8739ae039() {
    let selectedEstadoIds = [];
    function selectCheckedLoad(param) {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        let categoriaValue = params.getAll(param);
        return categoriaValue;
    }
    function renderizarCategoria(categorias, subcategorias) {
        const wrapperContainer = document.querySelector(".custom-dropdown-content .cols");
        const categoriasAgrupadas = {};
        // categorias.forEach((item) => {
        //   console.log(item)
        //   categoriasAgrupadas[tipoCategoria].push(item);
        // })
        categorias.forEach((item)=>{
            const tipoCategoria = item;
            if (!categoriasAgrupadas[tipoCategoria]) categoriasAgrupadas[tipoCategoria] = [];
            const filterSubCat = subcategorias.filter((subCat)=>subCat.categoria == tipoCategoria);
            categoriasAgrupadas[tipoCategoria].push(...filterSubCat);
        });
        const categoryOrder = [
            "Residenciais",
            "Comerciais",
            "Rurais",
            "Outros"
        ];
        const sortedCategories = Object.keys(categoriasAgrupadas).sort((a, b)=>categoryOrder.indexOf(a) - categoryOrder.indexOf(b));
        // Create a new object with sorted categories
        const sortedData = {};
        sortedCategories.forEach((category)=>{
            sortedData[category] = categoriasAgrupadas[category];
        });
        let htmlGrupo = "";
        for(const key in sortedData){
            const item = categoriasAgrupadas[key];
            let specialCategories = [];
            if (key == "Residenciais") specialCategories = [
                "apartamento",
                "cobertura",
                "casa/sobrado",
                "terreno/lote",
                "vaga de garagem"
            ];
            else if (key == "Comerciais") specialCategories = [
                "hot\xe9is",
                "salas/escrit\xf3rios",
                "galp\xe3o",
                "terreno/lote comercial",
                "im\xf3veis comerciais"
            ];
            else if (key == "Rurais") specialCategories = [
                "glebas",
                "fazenda",
                "ch\xe1cara / s\xedtio"
            ];
            else if (key == "Outros") specialCategories = [
                "ve\xedculos",
                "diversos"
            ];
            const htmlCategoria = item.sort((a, b)=>{
                // Check if both categories are in the specialCategories array
                const aIndex = specialCategories.indexOf(a.subcategoria.toLowerCase());
                const bIndex = specialCategories.indexOf(b.subcategoria.toLowerCase());
                // If both categories are in the specialCategories array, sort based on their index
                if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
                // If only one of them is in the specialCategories array, prioritize it
                if (aIndex !== -1) return -1;
                if (bIndex !== -1) return 1;
                return false;
            // If none of them are in the specialCategories array, sort alphabetically
            // return a.subcategoria.localeCompare(b.subcategoria);
            }).map((cat)=>{
                const urlParams = selectCheckedLoad("categoria");
                return `
              
                <label class="checkbox-container">
                    <input ${urlParams.includes(cat.id?.toString()) && "checked"}  type="checkbox" name="categoria" value="${cat.id}">
                    ${cat.subcategoria.toLowerCase()}
                </label>
                
                `;
            }).join("");
            htmlGrupo += `
            <div class="col-1">
                <h3 class="title-dropdown">${key}</h3>
                ${htmlCategoria}
            </div>
            `;
        }
        if (wrapperContainer) wrapperContainer.innerHTML = htmlGrupo;
    }
    function renderizarEstado(estados) {
        const wrapperEstados = document.querySelector("#estado-dropdown .cols");
        const htlmEstados = estados.map((estado)=>{
            const urlParams = selectCheckedLoad("estado");
            return `
            <label class="checkbox-container">
            <input ${urlParams.includes(estado.id?.toString()) && "checked"} type="checkbox" name="estado" value="${estado.id}">
            ${estado.nome.toLowerCase()}
            </label>
            `;
        }).join("");
        if (wrapperEstados) wrapperEstados.innerHTML = htlmEstados;
    }
    function renderizarCidades(cidades) {
        const wrapperContainer = document.querySelector("#cidade-dropdown .cols");
        const orderCidades = cidades?.sort((a, b)=>{
            const nomeA = a["cidade__nome"].toLowerCase();
            const nomeB = b["cidade__nome"].toLowerCase();
            if (nomeA < nomeB) return -1;
            if (nomeA > nomeB) return 1;
            return 0;
        });
        const htmlCidades = orderCidades.map((cidade)=>{
            const urlParams = selectCheckedLoad("cidade");
            return `
            <label class="checkbox-container">
            <input ${urlParams.includes(cidade.cidade__id?.toString()) && "checked"} type="checkbox" name="cidade" value="${cidade.cidade__id}">
            ${cidade.cidade__nome.toLowerCase()}
            </label>
            `;
        }).join("");
        if (wrapperContainer) wrapperContainer.innerHTML = htmlCidades;
    }
    async function carregarCidadesDosEstados(selectedEstadoIds) {
        try {
            const estadosParametros = selectedEstadoIds.map((estadoId)=>`estado=${estadoId}`).join("&");
            const response = await axios.get(`/filters/?${estadosParametros}`);
            if (response.data && response.data.cidades) {
                renderizarCidades(response.data.cidades);
                const cidadeTrigger = document.querySelector("#cidade-button");
                if (cidadeTrigger) {
                    cidadeTrigger.click();
                    cidadeTrigger.click();
                }
            // aqui
            } else renderizarCidades([]);
        } catch (error) {
            console.error(error);
        }
    }
    const estadoDropdown = document.querySelector("#estado-dropdown");
    estadoDropdown?.addEventListener("change", function(event) {
        const selectedEstados = document.querySelectorAll('#estado-dropdown input[type="checkbox"]:checked');
        selectedEstadoIds = Array.from(selectedEstados, (estado)=>estado.value);
        if (selectedEstadoIds.length > 0) carregarCidadesDosEstados(selectedEstadoIds);
        else renderizarCidades([]);
    });
    function renderizarBairros(bairros) {
        const wrapperContainer = document.querySelector("#bairro-dropdown .cols");
        const htmlBairros = bairros.sort((a, b)=>{
            const nomeA = a.toLowerCase();
            const nomeB = b.toLowerCase();
            if (nomeA < nomeB) return -1;
            if (nomeA > nomeB) return 1;
            return 0;
        }).map((bairro)=>{
            const urlParams = selectCheckedLoad("bairro");
            return `
            <label class="checkbox-container">
            <input ${urlParams.includes(bairro?.toString()) && "checked"} type="checkbox" name="bairro" value="${bairro}">
            ${bairro.toLowerCase()}
            </label>
            `;
        }).join("");
        if (wrapperContainer) wrapperContainer.innerHTML = htmlBairros;
    }
    async function carregarBairrosDaCidade(url) {
        console.log(url);
        try {
            const response = await axios.get(`/filters/${url}`);
            if (response.data && response.data.bairros) {
                renderizarBairros(response.data.bairros);
                const bairrosDropdown = document.querySelector("#bairro-button");
                if (bairrosDropdown) {
                    bairrosDropdown.click();
                    bairrosDropdown.click();
                }
            } else renderizarBairros([]);
        } catch (error) {
            console.error(error);
        }
    }
    const cidadeDropdown = document.querySelector("#cidade-dropdown");
    cidadeDropdown?.addEventListener("change", function(event) {
        const selectedCidades = document.querySelectorAll('#cidade-dropdown input[type="checkbox"]:checked');
        const selectedCidadeIds = Array.from(selectedCidades, (cidade)=>cidade.value);
        function createQueryStringWithKey(key, values) {
            const queryStringValues = values.map((value)=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            return `?${queryStringValues.join("&")}`;
        }
        const key = "cidade";
        const values = [
            "s\xe3o paulo",
            "Pedra Azul"
        ];
        const queryString = createQueryStringWithKey(key, selectedCidadeIds);
        if (selectedCidadeIds.length > 0) carregarBairrosDaCidade(queryString);
    });
    function renderizarFaixaPreco(faixasDePreco) {
        const wrapperContainer = document.querySelector("#preco-dropdown");
        const htmlFaixasDePreco = faixasDePreco.map((faixa)=>{
            const urlParams = selectCheckedLoad("faixa_preco");
            return `
          <label class="checkbox-container">
            <input ${urlParams.includes(faixa?.toString()) && "checked"} type="checkbox" name="faixa_preco" value="${faixa}">
            ${faixa}
          </label>
        `;
        }).join("");
        if (wrapperContainer) wrapperContainer.innerHTML = htmlFaixasDePreco;
    }
    function getTotal() {
        const items = document.querySelectorAll(".list-items .item");
        items.forEach((item)=>{
            const inputs = item.querySelectorAll("input");
            const totalEl = item.querySelector(".total-items");
            let totalChecked = 0;
            inputs.forEach((input)=>{
                if (input.checked) totalChecked++;
            });
            if (totalChecked) totalEl.innerText = totalChecked;
            else if (totalEl) totalEl.innerText = "";
        });
    }
    axios.get("/filters/").then((response)=>{
        if (response.data && response.data.estados) {
            renderizarCategoria(response.data.categorias, response.data.subcategorias);
            renderizarEstado(response.data.estados);
            renderizarFaixaPreco(response.data.faixas_preco);
            const estado = selectCheckedLoad("estado");
            const cidades = selectCheckedLoad("cidade");
            console.log("estado ", estado);
            console.log(cidades, "cidades");
            const dropIconTrigger = document.querySelector("#estado-button");
            const categoriasnTrigger = document.querySelector("#categorias-button");
            const precoTrigger = document.querySelector("#preco-button");
            if (precoTrigger) {
                precoTrigger.click();
                precoTrigger.click();
            }
            if (categoriasnTrigger) {
                categoriasnTrigger.click();
                categoriasnTrigger.click();
            }
            if (dropIconTrigger) {
                dropIconTrigger.click();
                dropIconTrigger.click();
            }
            if (estado && estado.length) carregarCidadesDosEstados(estado);
            if (cidades && cidades.length) {
                const cidadeParametros = cidades.map((cidadeId)=>`cidade=${cidadeId}`).join("&");
                console.log("paramsss", cidadeParametros);
                carregarBairrosDaCidade(`?${cidadeParametros}`);
            }
            getTotal();
        }
    }).catch((error)=>{
        console.error(error);
    });
    const items = document.querySelectorAll(".list-items .item");
    items?.forEach((item)=>{
        item?.addEventListener("click", (e)=>{
            const listaItems = e.target.closest(".list-items .item");
            const inputs = listaItems.querySelectorAll("input");
            const totalEl = item.querySelector(".total-items");
            let totalChecked = 0;
            inputs.forEach((input)=>{
                if (input.checked) totalChecked++;
            });
            console.log("Total de itens checados:", totalChecked);
            if (!totalEl) return;
            if (totalChecked) {
                totalEl.innerText = totalChecked;
                totalEl.style.display = "inline-block";
            } else {
                totalEl.innerText = "";
                totalEl.style.display = "none";
            }
        });
    });
    const formFilter = document.querySelector("#filter form");
    formFilter.addEventListener("submit", (e)=>{
        e.preventDefault();
        let inputSearch = formFilter.querySelector(".busca");
        let userSearch = inputSearch.value;
        let clearSpace = userSearch.trim();
        if (clearSpace) {
            const radioTodosLeiloes = document.querySelector('.home-list-filter-bottom [data-filter="all"]');
            const checkboxes = formFilter.querySelectorAll('[type="checkbox"]');
            checkboxes.forEach((cb)=>cb.checked = false);
            radioTodosLeiloes.click();
        }
        e.target.submit();
        inputSearch.value = clearSpace;
    });
    function filtrosTipoLeilao() {
        const btnsDataFilter = document.querySelectorAll("[data-filter]");
        const params = new URLSearchParams(window.location.search);
        const selectedTyes = params.getAll("tipo_leilao");
        const createInputs = (types)=>types.forEach((type)=>{
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = "tipo_leilao";
                input.value = type;
                formFilter.appendChild(input);
            });
        if (selectedTyes.length) createInputs(selectedTyes);
        // Adicionando classe inicial
        if (selectedTyes.length === 1) btnsDataFilter[2].querySelector(".pin").classList.add("active");
        else if (selectedTyes.length > 1) btnsDataFilter[1].querySelector(".pin").classList.add("active");
        else btnsDataFilter[0].querySelector(".pin").classList.add("active");
        btnsDataFilter.forEach((btn)=>btn.addEventListener("click", ()=>{
                [
                    ...formFilter.querySelectorAll('input[name="tipo_leilao"]')
                ].forEach((el)=>el?.remove());
                btnsDataFilter.forEach((btn)=>btn?.querySelector(".pin.active")?.classList.remove("active"));
                btn.querySelector(".pin").classList.add("active");
                const types = {
                    all: [],
                    trt: [
                        "TRT"
                    ],
                    not_trt: [
                        "JUDICIAL",
                        "EXTRAJUDICIAL",
                        "ALIENA\xc7\xc3O PARTICULAR",
                        "BENEFICENTE"
                    ]
                };
                const btnType = btn.dataset.filter;
                createInputs(types[btnType]);
            // formFilter.submit()
            }));
    }
    function fillSearch() {
        const params = new URLSearchParams(window.location.search);
        const search = params.get("search");
        if (search) document.querySelector('form [name="search"]').value = search;
    }
    filtrosTipoLeilao();
    fillSearch();
}


function $9a9c240ea370a410$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#form-submit");
    const btnSubmit = document.querySelector(".leilao-judicial .btn");
    if (!contatoFormSubmit || !btnSubmit) return;
    async function showMessage(response) {
        const message = response.data ? response.data.status : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        // enableDisableBtn(false)
        setTimeout(()=>enableDisableBtn(false), 1000);
    }
    function enableDisableBtn(state) {
        btnSubmit.disabled = state;
        btnSubmit.style.opacity = state ? "0.5" : "1.0";
    }
    function handleSubmitForm(e) {
        e.preventDefault();
        enableDisableBtn(true);
        const captchaResponse = window.grecaptcha.getResponse();
        if (!document.querySelector("#captcha-validade1").value) {
            const response = {
                message: "Ocorreu um erro ao enviar o formul\xe1rio. Tente outra vez"
            };
            showMessage(response);
            return;
        }
        const formValue = new FormData(e.currentTarget);
        const url = e.currentTarget.dataset.action;
        axios.post(url, formValue).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    }
    contatoFormSubmit.addEventListener("submit", handleSubmitForm);
}


function $218c5ca1fa4ca2d1$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#form-submit-lej");
    const btnSubmit = document.querySelector(".leilao-extra-judicial .btn");
    if (!contatoFormSubmit || !btnSubmit) return;
    async function showMessage(response) {
        const message = response.data ? response.data.status : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(()=>enableDisableBtn(false), 1000);
    }
    function enableDisableBtn(state) {
        btnSubmit.disabled = state;
        btnSubmit.style.opacity = state ? "0.5" : "1.0";
    }
    function handleSubmitForm(e) {
        e.preventDefault();
        enableDisableBtn(false);
        const captchaResponse = window.grecaptcha.getResponse();
        console.log("aaaa", captchaResponse);
        if (!document.querySelector("#captcha-validade2").value) {
            const response = {
                message: "Ocorreu um erro ao enviar o formul\xe1rio. Tente outra vez"
            };
            showMessage(response);
            return;
        }
        const formValue = new FormData(e.currentTarget);
        const url = e.currentTarget.dataset.action;
        axios.post(url, formValue).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    }
    contatoFormSubmit.addEventListener("submit", handleSubmitForm);
}


function $b584bf405b315cc7$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#form-submit-rn");
    const btnSubmit = document.querySelector(".news-letter-form .btn-form-news-letter");
    if (!contatoFormSubmit || !btnSubmit) return;
    async function showMessage(response) {
        const message = response.data ? response.data.status : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(()=>enableDisableBtn(true), 1000);
    }
    function enableDisableBtn(state) {
        btnSubmit.disabled = state;
        btnSubmit.style.opacity = state ? "1.0" : "0.5";
    }
    function handleSubmitForm(e) {
        e.preventDefault();
        enableDisableBtn(false);
        const formValue = new FormData(e.currentTarget);
        const url = e.currentTarget.dataset.action;
        axios.post(url, formValue).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    }
    contatoFormSubmit.addEventListener("submit", handleSubmitForm);
}


function $0bf6615cbaf207a0$export$2e2bcd8739ae039() {
    function showPasswordResetModal() {
        const modal = document.getElementById("id-password-reset");
        modal.style.display = "block";
    }
    function hidePasswordResetModal() {
        const modal = document.getElementById("id-password-reset");
        modal.style.display = "none";
    }
    // Substitua pelo seletor do elemento pai
    // Adiciona um event listener ao elemento pai
    document.addEventListener("click", function(event) {
        // Verifica se o elemento clicado é o #lembrarSenhaLink
        if (event.target.matches("#lembrarSenhaLink")) {
            event.preventDefault();
            showPasswordResetModal();
        }
    });
    document.querySelector(".modal-close")?.addEventListener("click", function() {
        hidePasswordResetModal();
    });
    window.addEventListener("click", function(event) {
        const modal = document.getElementById("id-password-reset");
        if (event.target === modal) hidePasswordResetModal();
    });
}


function $30b8c90610d9fb6b$export$2e2bcd8739ae039() {
    // Handler de scroll coalescido via requestAnimationFrame: no maximo uma
    // leitura/escrita de layout por frame, em vez de uma por evento de scroll.
    // Elemento cacheado fora do handler e listener passivo para nao bloquear o scroll.
    let headerEl = document.querySelector("#header");
    let scrollTicking = false;
    window.addEventListener("scroll", function() {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function() {
            scrollTicking = false;
            if (!headerEl) headerEl = document.querySelector("#header");
            if (!headerEl) return;
            headerEl.classList.toggle("sticky", window.scrollY > 550);
        });
    }, {
        passive: true
    });
    const btnMobile = document.getElementById("btn-mobile");
    function toggleMenu() {
        const nav = document.getElementById("nav");
        nav.classList.toggle("active");
    }
    btnMobile.addEventListener("click", toggleMenu);
    function renderizarTipoLeilao() {
        const tipoLeilao = document.querySelector(".dropdown-menu .dropdown-content");
        const tLeilao = [
            "Todos os Leil\xf5es",
            "TJ e Extrajudicial",
            "Justi\xe7a Trabalhista",
            "Encerrados"
        ];
        if (!tipoLeilao) return;
        const htmlTipoLeilao = tLeilao.map((tipo)=>{
            let params = "";
            if (tipo == "Todos os Leil\xf5es") params = ``;
            else if (tipo == "TJ e Extrajudicial") params = `?tipo_leilao=JUDICIAL&tipo_leilao=EXTRAJUDICIAL&tipo_leilao=ALIENA\xc7\xc3O PARTICULAR&status=Aberto&status=Futuro&status=Em breve&filter_first=1`;
            else if (tipo == "Justi\xe7a Trabalhista") params = `?&tipo_leilao=TRT`;
            else if (tipo == "Encerrados") params = `?status=Vendido&order_p=Vendido`;
            else params = `?tipo_leilao=${tipo}`;
            return `<a href="/leiloes/${params}">${tipo}</a>`;
        }).join("");
        tipoLeilao.innerHTML = htmlTipoLeilao;
    }
    renderizarTipoLeilao();
    const anchorTags = document.querySelectorAll(".dropdown-content a");
// Loop through each anchor tag and capitalize the first letter of each word
// Loop through each anchor tag and capitalize the first letter of each word
// anchorTags.forEach((anchor) => {
//     const words = anchor.textContent.split(' ');
//     const capitalizedWords = words.map((word) => {
//       if(word == 'E') {
//         console.log('aqui ?' ,word)
//         return word.toLocaleLowerCase()
//       }
//         return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//     });
//     anchor.textContent = capitalizedWords.join(' ');
// });
}


function $4f48a405199b0c28$export$2e2bcd8739ae039() {
    const btnJudicial = document.getElementById("btn-judicial");
    const btnExtraJudicial = document.getElementById("btn-extra-judicial");
    const leilaoJudicial = document.querySelector(".leilao-judicial");
    const leilaoExtraJudicial = document.querySelector(".leilao-extra-judicial");
    function toggleDiv(div) {
        div.classList.toggle("show");
    }
    btnJudicial.addEventListener("click", ()=>{
        toggleDiv(leilaoJudicial);
        leilaoExtraJudicial.classList.remove("show");
    });
    btnExtraJudicial.addEventListener("click", ()=>{
        toggleDiv(leilaoExtraJudicial);
        leilaoJudicial.classList.remove("show");
    });
}


function $e731afd83ee73348$export$2e2bcd8739ae039(seletor) {
    const btnCadastro = document.getElementById(seletor || "cadastre-se");
    const modalCadastro = document.getElementById("modalCadastre-se");
    const fecharModalCadastro = document.getElementById("fechar-modal-cadastro");
    const footerCadastro = document.querySelector("#alfa_leiloes_footer #cadastre-se");
    if (btnCadastro) btnCadastro.addEventListener("click", function(event) {
        event.preventDefault();
        modalCadastro.style.display = "block";
        document.body.classList.add("modal-open");
    });
    if (fecharModalCadastro) fecharModalCadastro.addEventListener("click", function() {
        modalCadastro.style.display = "none";
        document.body.classList.remove("modal-open");
    });
    window.addEventListener("click", function(event) {
        if (event.target === modalCadastro) {
            modalCadastro.style.display = "none";
            document.body.classList.remove("modal-open");
        }
    });
    function abrirModalCadastro() {
        const modalCadastro = document.getElementById("modalCadastre-se");
        if (modalCadastro) {
            modalCadastro.style.display = "block";
            document.body.classList.add("modal-open");
        }
    }
    console.log(footerCadastro);
    if (footerCadastro) footerCadastro.addEventListener("click", abrirModalCadastro);
}


(0, $90676fd7b60b5338$export$1aee95c530b1861b)();
(0, $90676fd7b60b5338$export$9257625807ef4b3a)();
(0, $0377339b390f9aed$export$3a4ac90595086862)();
// PAGES
const $ad253d60d7afe5ec$var$pageHome = document.querySelector(".page_inicial");
const $ad253d60d7afe5ec$var$pageQuemSomos = document.querySelector(".body_quem_somos");
const $ad253d60d7afe5ec$var$pageItem = document.querySelector(".page_item");
const $ad253d60d7afe5ec$var$pageItems = document.querySelector(".page_items");
const $ad253d60d7afe5ec$var$pageMinhaConta = document.querySelector(".page_minha_conta");
const $ad253d60d7afe5ec$var$pageHomologado = document.querySelector(".page_homologado");
const $ad253d60d7afe5ec$var$pageCadastroFisico = document.querySelector(".page_cadastro_fisico");
const $ad253d60d7afe5ec$var$pageCadastroJuridico = document.querySelector(".page_cadastro_juridico");
const $ad253d60d7afe5ec$var$pageLoteGrupo = document.querySelector(".page_lote_grupo");
(0, $6074568c9c4450be$export$2e2bcd8739ae039)();
(0, $2914c72b259257f0$export$2e2bcd8739ae039)();
(0, $9a9c240ea370a410$export$2e2bcd8739ae039)();
(0, $218c5ca1fa4ca2d1$export$2e2bcd8739ae039)();
(0, $b584bf405b315cc7$export$2e2bcd8739ae039)();
(0, $30b8c90610d9fb6b$export$2e2bcd8739ae039)();
(0, $e731afd83ee73348$export$2e2bcd8739ae039)();
function $ad253d60d7afe5ec$var$getURLParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        titulo: urlParams.get("titulo"),
        mensagem: urlParams.get("toastify")
    };
}
const $ad253d60d7afe5ec$var$toastifyValue = $ad253d60d7afe5ec$var$getURLParameter();
console.log($ad253d60d7afe5ec$var$toastifyValue);
if ($ad253d60d7afe5ec$var$toastifyValue.titulo || $ad253d60d7afe5ec$var$toastifyValue.mensagem) Swal.fire({
    position: "top",
    title: $ad253d60d7afe5ec$var$toastifyValue.titulo,
    text: $ad253d60d7afe5ec$var$toastifyValue.mensagem,
    showCloseButton: true,
    showConfirmButton: false,
    color: "#111"
});
// ★ Pages Scopo
if ($ad253d60d7afe5ec$var$pageHome) {
    (0, $7b5c18274c293bb7$export$2e2bcd8739ae039)();
    (0, $d39faeca8f198153$export$2e2bcd8739ae039)();
    (0, $10c50974faba5f51$export$2e2bcd8739ae039)();
    (0, $0fa4be6d176625ab$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageQuemSomos) (0, $ddc583c3c80e0943$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageItem) ;
else if ($ad253d60d7afe5ec$var$pageItems) {
    (0, $10c50974faba5f51$export$2e2bcd8739ae039)();
    (0, $0fa4be6d176625ab$export$2e2bcd8739ae039)();
// loteGrupo()
// AlfaLeiloesHome();
// addFilterURLAndReload();
// Filter();
// alfaLeiloesSwiperCards();
} else if ($ad253d60d7afe5ec$var$pageMinhaConta) ;
else if ($ad253d60d7afe5ec$var$pageHomologado) (0, $4f48a405199b0c28$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageCadastroFisico) ;
else $ad253d60d7afe5ec$var$pageCadastroJuridico;
// else if (pageLoteGrupo) {
//   Filter()
//   loteGrupo()
// }
(0, $0bf6615cbaf207a0$export$2e2bcd8739ae039)();
document.addEventListener("DOMContentLoaded", ()=>{
    document.body.classList.add("dcl");
    document.body.classList.add("DomContentLoaded");
    (0, $90676fd7b60b5338$export$7d8bd70438e04f3a)();
    function FMoney(value, opts) {
        if (!value) return;
        const result = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            ...opts
        }).format(value);
        return result;
    }
    document.querySelectorAll("[js-money]")?.forEach((i)=>{
        if (i.innerText == "None") return;
        const val = FMoney(i.innerText?.replace(",", ".").trim());
        i.innerText = val ? val : "-";
    });
    var lazyLoadInstance = new LazyLoad({
    });
    function onSubmitRecaptcha(e) {
        console.log("oie");
    }
    window.onSubmitRecaptcha = onSubmitRecaptcha;
});

})();
//# sourceMappingURL=main.js.map
